<template>
    <div :class="$style.container" id="loading" v-loading.fullscreen.lock.body="loading" element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">

        <el-row>
            <el-col :span="14">
                <div style="font-size: 18px;padding: 20px;padding-top: 28px;font-weight: bold;">
                    客户数据采集 <span style="color: #2b92fa">{{'['+subTitle+']'}}</span>
                </div>
            </el-col>
            <el-col :span="10" v-if="is_staff_false" style="height: 80px; display: flex;justify-content: flex-end;">
                <div style="padding: 20px;padding-top: 28px;" class="people">
                    <el-form ref="form" :model="form" label-width="80px">
                        <el-form-item label="管理辖区">
                            <el-select v-model="form.TerritoryList" placeholder="请选择" @change="xuanze">
                                <el-option v-for="item in TerritoryList" :key="item.territory_id"
                                    :label="item.territory_name" :value="item.territory_id" :disabled="!is_staff_false">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-form>
                </div>
                <div style="width: 100px;">
                    <div style="height: 85px;text-align: center;line-height: 96px;padding-right:20px; ">
                        <el-button type="danger" @click.stop="handleBackClick" size="small" class="icon">
                            <i :class="['iconfont', 'icon-back']" style="position: relative;top:1px"></i>
                            返回</el-button>
                    </div>
                </div>
            </el-col>
        </el-row>
        <div class="box">
            <div class="zuo" style="position: relative;left: 20px">
                <img src="../../../assets/images/zuo.png" alt="">
            </div>
            <div class="swiper-container" ref="swiperContainer">
                <div class="swiper-wrapper">

                    <div class="swiper-slide" v-for="item in array"
                        :style="{backgroundColor:item.isSelect?'#ECF3FC':'#fff',borderColor:item.isSelect?'#4A90E2':'#ededed'}">
                        <div @click="dianji3(item)" style="cursor: pointer;">
                            <el-row style="padding: 10px" v-if="item.territory_code !==''">
                                <el-col :span="21">
                                    <span style="color: #4D586D;font-size: 14px">{{item.territory_name}}<br />
                                        ({{item.territory_code}})
                                        <span v-if="item.owner_name"
                                            style="border: 1px solid #FF9901;background-color: #FF9901;color: #fff;font-size: 11px;border-radius:3px">
                                            {{item.owner_name}}
                                        </span>
                                    </span>
                                </el-col>
                                <el-col :span="3">
                                    <img :src="item.isSelect?imgarr[1]:imgarr[0]" alt="">
                                </el-col>
                            </el-row>
                            <el-row style="padding: 10px" v-else-if="item.territory_code ==''">
                                <el-col :span="24">
                                    <span style="color: #4D586D;font-size: 14px">{{item.territory_name}}</span>
                                </el-col>
                            </el-row>
                            <el-row style="margin-left: 10px;" v-if="item.customTable_staff_submit=='T'">
                                <el-col :span="21">
                                    <span style="margin-right: 1px;" v-if="item.customTable_staff_submit=='T'">
                                        <el-tag size="mini" type="warning" effect="plain">
                                            代表已提交
                                        </el-tag>
                                    </span>
                                </el-col>
                            </el-row>
                            <el-row style="margin-left: 10px;"
                                v-if="item.customTable_submit=='T' ||item.customTable_approve=='T'">
                                <el-col :span="21">
                                    <span style="margin-right: 1px;" v-if="item.customTable_approve=='T'">
                                        <el-tag size="mini" type="success" effect="plain" style=" margin-top: 5px;">
                                            主管已审核
                                        </el-tag>
                                    </span>
                                    <span style="margin-right: 1px;" v-if="item.customTable_submit=='T'">
                                        <el-tag size="mini" type="warning" effect="plain">
                                            主管已提交
                                        </el-tag>
                                    </span>
                                </el-col>
                            </el-row>
                            <!-- <el-row style="padding:10px 10px">
                                <el-col :span="4"><span v-if="item.owner_name"
                                        style="border: 1px solid #FF9901;background-color: #FF9901;color: #fff;font-size: 11px;border-radius:3px">{{item.owner_name}}</span></el-col>
                                <el-col :span="6"><span style="color: #B0B5B9;font-size: 9px">职务：{{item.title}}
                                    </span></el-col>
                                <el-col :span="14"><span
                                        style="color: #B0B5B9;font-size: 9px">入职日期：{{item.onboard_date}}
                                    </span></el-col>
                            </el-row>

                            <el-row style="padding:0 0 0 10px;font-size: 14px">
                                <span style="color: #7ED321;">{{item.product_num}}个产品</span>
                                <span style="color: #4A90E2;margin-left: 30px"
                                    v-if="clientObj.showInstitution">机构{{item.institution_num}}家 </span>
                                <span style="color: #4A90E2" v-if="clientObj.showStore">门店{{item.retailstore_num}}家 
                                </span>
                                <span style="color: #4A90E2"
                                    v-if="clientObj.showDistributor">经销商{{item.distributor_num}}家</span>
                            </el-row> -->

                        </div>
                        <!-- <span style="position: relative;right: 10px;">
                            <img :src="item.isSelect?imgarr[1]:imgarr[0]" alt="">
                        </span> -->
                    </div>
                </div>
            </div>
            <div class="you" style="position: relative;right: 20px">
                <img src="../../../assets/images/you.png" alt="">
            </div>
        </div>
        <div style="margin-top: 10px;">
            <el-row style="margin-left: 58px; margin-right: 58px;">
                <el-col :span="18">
                    <el-checkbox v-model="checked_staff_draft"
                        @change="handleCheckFilter">代表未提交({{territory_staff_draft_count}})</el-checkbox>
                    <el-checkbox v-model="checked_staff_submited"
                        @change="handleCheckFilter">代表已提交({{territory_staff_submited_count}})</el-checkbox>
                    <el-checkbox v-model="checked_manager_no_approved"
                        @change="handleCheckFilter">代表已提交主管未审核({{territory_manager_no_approved_count}})</el-checkbox>
                    <el-checkbox v-model="checked_manager_approved"
                        @change="handleCheckFilter">主管已审核({{territory_manager_approved_count}})</el-checkbox>
                    <el-checkbox v-model="checked_manager_submited"
                        @change="handleCheckFilter">主管已提交({{territory_manager_submited_count}})</el-checkbox>
                </el-col>
                <el-col :span="6">
                    <el-checkbox style="float: right;" v-model="checked"
                        @change="dianji4">选中以上所有终端辖区({{array.length}})</el-checkbox>
                </el-col>
            </el-row>
        </div>

        <el-row style="margin-top: 20px">
            <el-col :span="14">
                <span v-if="territoryArray.length==1" style="padding-left: 20px;line-height: 40px;color: #4A90E2;min-width: 1px">
                    {{territory_name}} {{territory_code}}
                </span>
                <span v-if="territoryArray.length==1 && alias">
                    <span
                        style="background-color: #ff9901;color: #fff;font-size: 12px;border: 1px solid #ff9901;padding: 0 2px;border-radius: 3px">{{alias}}</span>
                </span>
                <span v-if="territoryArray.length>1" style="padding-left: 20px;line-height: 40px;color: #4A90E2;min-width: 1px">
                    多个辖区
                </span>
                <span>
                    <span style="margin-left: 20px;color: #585757;">医院名称：</span>
                    <el-select
                        style="width: 300px;"
                        v-model="search_keyword"
                        filterable
                        clearable
                        remote
                        reserve-keyword
                        placeholder="请输入医院名称"
                        @change="changeSelectInstitution"
                        :remote-method="remoteSearchMethod"
                        :loading="loading">
                        <el-option
                            v-for="item in search_institution_options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </span>
            </el-col>
            <el-col :span="10">
                <div style="float: right;margin-right: 20px;">
                    <!-- <el-button type="primary" icon="el-icon-plus" size="small" @click="handleCustomAdd">添加新纪录</el-button> -->
                    <el-button v-if="is_staff_false" type="success" size="small"
                        @click="handleCustomApproveSubmit('APPROVE')" icon="el-icon-circle-check">审核</el-button>
                    <el-button v-if="is_staff_false" type="warning" size="small"
                        @click="handleCustomApproveSubmit('SUBMIT')" icon="el-icon-s-promotion">提交</el-button>
                    <!-- <el-button v-if="is_staff_false && activeName=='five'" type="primary" size="small"
                        @click="handleDownloadExpoler()" icon="el-icon-download">采集情况统计</el-button> -->
                    <el-button v-if="is_staff_false && activeName=='five' && data.group_code=='ZR_MONTH_TASK'" type="primary" size="small"
                        @click="handleDownloadCollectData()" icon="el-icon-download">采集填报明细数据下载</el-button>
                </div>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24" style="padding: 20px;padding-top: 0">
                <template>
                    <el-tabs v-model="activeName" @tab-click="handleTabClick">
                        <el-tab-pane label="机构" v-if="data.reference_obj.includes('INSTITUTION')" name="first">
                            <el-row>
                                <el-col :span="24">
                                    <p style="color: #2b92fa;margin:0;line-height: 25px;">采集字段（{{fieldArray.length}}个）：
                                        <span
                                            style="line-height: 22px;font-size: 14px;text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 5px; "
                                            v-for="item in fieldArray">{{item.field_name}}</span>
                                    </p>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24" style="margin-top: 20px;margin-bottom: 10px;">
                                    <el-table :data="insTableData" border style="width: 100%">
                                        <el-table-column fixed type="index" label="序号" width="50">
                                        </el-table-column>
                                        <el-table-column min-width="400" prop="institution_name" sortable label="客户">
                                        </el-table-column>
                                        <el-table-column prop="fill_num" sortable label="已填字段数" width="120">
                                        </el-table-column>
                                        <el-table-column prop="timestamp" sortable label="最后填写日期" width="220">
                                            <template slot-scope="scope">
                                                <span v-if="!scope.row.timestamp">
                                                    -
                                                </span>
                                                <span v-else>
                                                    {{scope.row.timestamp}}
                                                </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column fixed="right" label="操作" width="88">
                                            <template slot-scope="scope">
                                                <el-button @click="handleClick(scope.row)"
                                                    style="color: #fff;background: #FE904C;border:none;border-radius: 10%"
                                                    size="small">详情</el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <pagination :page="page" @changePage="changePageClick"></pagination>
                                </el-col>
                            </el-row>
                        </el-tab-pane>
                        <el-tab-pane label="HCP" v-if="data.reference_obj.includes('HCP')" name="second">
                            <el-col :span="24">
                                <p style="color: #2b92fa;margin:0;line-height: 25px;">采集字段（{{fieldArray.length}}个）：<span
                                        style="line-height: 22px;font-size: 14px;text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 5px; "
                                        v-for="item in fieldArray">{{item.field_name}}</span></p>
                            </el-col>
                            <el-row>
                                <el-col :span="24" style="margin-top: 20px;height: 400px;">
                                    <el-table :data="hcpTableData" border style="width: 100%">
                                        <el-table-column fixed type="index" label="序号" width="50">
                                        </el-table-column>
                                        <el-table-column prop="hcp_name" sortable label="客户" min-width="350">
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.reference_obj == 'HCP'">
                                                    {{
                                                    scope.row.institution_name +' | '+scope.row.dept_name +' | '+scope.row.job_title +' | '+scope.row.hcp_name}}
                                                </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="segment_id" sortable label="客户级别" width="120">
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.segment_id" style="color: #4BBFEF">
                                                    {{scope.row.segment_id}}
                                                </span>
                                                <span v-else style="color: #4BBFEF">
                                                    -
                                                </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="status" sortable label="目标客户" width="120">
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.status == 'ACTIVE'" style="color: #4BBFEF">
                                                    是
                                                </span>
                                                <span v-else style="color: #4BBFEF">
                                                    否
                                                </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="fill_num" sortable label="已填字段数" width="120">
                                        </el-table-column>
                                        <el-table-column prop="timestamp" sortable label="最后填写日期" width="220">
                                            <template slot-scope="scope">
                                                <span v-if="!scope.row.timestamp">
                                                    -
                                                </span>
                                                <span v-else>
                                                    {{scope.row.timestamp}}
                                                </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column fixed="right" label="操作" width="88">
                                            <template slot-scope="scope">
                                                <el-button @click="handleClick(scope.row)"
                                                    style="color: #fff;background: #FE904C;border:none;border-radius: 10%"
                                                    size="small">详情</el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <pagination :page="page" @changePage="changePageClick"></pagination>
                                </el-col>
                            </el-row>
                        </el-tab-pane>
                        <el-tab-pane label="门店" v-if="data.reference_obj.includes('RETAILSTORE')" name="third">
                            <el-col :span="24">
                                <p style="color: #2b92fa;margin:0;line-height: 25px;">采集字段（{{fieldArray.length}}个）：<span
                                        style="line-height: 22px;font-size: 14px;text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 5px; "
                                        v-for="item in fieldArray">{{item.field_name}}</span></p>
                            </el-col>
                            <el-row>
                                <el-col :span="24" style="margin-top: 20px;height: 400px;">
                                    <el-table :data="storeTableData" border style="width: 100%">
                                        <el-table-column fixed type="index" label="序号" width="50">
                                        </el-table-column>
                                        <el-table-column min-width="400" prop="store_name" sortable label="客户">
                                        </el-table-column>
                                        <el-table-column prop="segment_id" sortable label="客户级别" width="120">
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.segment_id" style="color: #4BBFEF">
                                                    {{scope.row.segment_id}}
                                                </span>
                                                <span v-else style="color: #4BBFEF">
                                                    -
                                                </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="status" sortable label="目标客户" width="120">
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.status == 'ACTIVE'" style="color: #4BBFEF">
                                                    是
                                                </span>
                                                <span v-else style="color: #4BBFEF">
                                                    否
                                                </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="fill_num" sortable label="已填字段数" width="120">
                                        </el-table-column>
                                        <el-table-column prop="timestamp" sortable label="最后填写日期" width="220">
                                            <template slot-scope="scope">
                                                <span v-if="!scope.row.timestamp">
                                                    -
                                                </span>
                                                <span v-else>
                                                    {{scope.row.timestamp}}
                                                </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column fixed="right" label="操作" width="88">
                                            <template slot-scope="scope">
                                                <el-button @click="handleClick(scope.row)"
                                                    style="color: #fff;background: #FE904C;border:none;border-radius: 10%"
                                                    size="small">详情</el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <pagination :page="page" @changePage="changePageClick"></pagination>
                                </el-col>
                            </el-row>
                        </el-tab-pane>
                        <el-tab-pane label="经销商" v-if="data.reference_obj.includes('DISTRIBUTOR')" name="fourth">
                            <el-col :span="24">
                                <p style="color: #2b92fa;margin:0;line-height: 25px;">采集字段（{{fieldArray.length}}个）：<span
                                        style="line-height: 22px;font-size: 14px;text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 5px; "
                                        v-for="item in fieldArray">{{item.field_name}}</span></p>
                            </el-col>
                            <el-row>
                                <el-col :span="24" style="margin-top: 20px;height: 400px;">
                                    <el-table :data="disTableData" border style="width: 100%">
                                        <el-table-column fixed type="index" label="序号" width="50">
                                        </el-table-column>
                                        <el-table-column min-width="400" prop="distributor_name" sortable label="客户">
                                        </el-table-column>
                                        <el-table-column prop="segment_id" sortable label="客户级别" width="120">
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.segment_id" style="color: #4BBFEF">
                                                    {{scope.row.segment_id}}
                                                </span>
                                                <span v-else style="color: #4BBFEF">
                                                    -
                                                </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="status" sortable label="目标客户" width="120">
                                            <template slot-scope="scope">
                                                <span v-if="scope.row.status == 'ACTIVE'" style="color: #4BBFEF">
                                                    是
                                                </span>
                                                <span v-else style="color: #4BBFEF">
                                                    否
                                                </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="fill_num" sortable label="已填字段数" width="120">
                                        </el-table-column>
                                        <el-table-column prop="timestamp" sortable label="最后填写日期" width="220">
                                            <template slot-scope="scope">
                                                <span v-if="!scope.row.timestamp">
                                                    -
                                                </span>
                                                <span v-else>
                                                    {{scope.row.timestamp}}
                                                </span>
                                            </template>
                                        </el-table-column>
                                        <el-table-column fixed="right" label="操作" width="88">
                                            <template slot-scope="scope">
                                                <el-button @click="handleClick(scope.row)"
                                                    style="color: #fff;background: #FE904C;border:none;border-radius: 10%"
                                                    size="small">详情</el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <pagination :page="page" @changePage="changePageClick"></pagination>
                                </el-col>
                            </el-row>
                        </el-tab-pane>

                        <el-tab-pane label="自定义表格" v-if="data.reference_obj.includes('CUSTOMTABLE')" name="five">
                            <el-col :span="24">
                                <p style="color: #2b92fa;margin:0;line-height: 25px;">采集字段（{{fieldArray.length}}个）：<span
                                        style="line-height: 22px;font-size: 14px;text-align: center;color: #FF9C00;border:1px solid #FF9C00;padding: 0px 2px;border-radius: 5px;margin-right: 5px; "
                                        v-for="item in fieldArray">{{item.field_name}}</span></p>
                            </el-col>
                            <el-row>
                                <el-col :span="24" style="margin-top: 20px;height: 400px;">
                                    <el-table :data="customTableData" border style="width: 100%" max-height="380">
                                        <el-table-column fixed type="index" label="序号" width="50">
                                        </el-table-column>
                                        <el-table-column v-for="item in customTableHeader">
                                            <template slot="header" slot-scope="scope">
                                                {{item.field_name}}
                                            </template>
                                            <template slot-scope="scope">
                                                <div v-if="item.field_id!='rule'">{{getCustomTableScopeFieldValue(item,scope.$index)}}</div>
                                                <div plain="true" v-if="item.field_id=='rule'">
                                                    <div v-html="getCustomTableScopeFieldValue(item,scope.$index)"></div>
                                                </div>
                                            </template>
                                        </el-table-column>
                                        <el-table-column fixed="right" label="操作" width="88">
                                            <template slot-scope="scope">
                                                <el-button @click="handleCustomTableClick(scope.row)"
                                                    style="color: #fff;background: #FE904C;border:none;border-radius: 10%"
                                                    size="small">详情</el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                    <!-- <pagination :page="page" @changePage="changePageCustomTableClick"></pagination> -->
                                </el-col>
                            </el-row>
                        </el-tab-pane>
                    </el-tabs>
                </template>
            </el-col>
        </el-row>


        <el-dialog id="customInfo" :visible.sync="dialogDetails" width="900px" :show-close="false"
            style="vertical-align: center;">
            <div style="">
                <el-row style="padding-bottom: 20px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;font-size: 26px">{{name}}
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div align="right">
                            <el-button type="primary" size="small" v-if="activeName2 == 'second' && isdisable == false"
                                @click.stop="add">
                                保存
                            </el-button>
                            <el-button type="danger" size="small" @click.stop="close">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <el-tabs v-model="activeName2">
                    <el-tab-pane label="基本信息" name="first">
                        <div id="collect_field" style="margin-top: 20px;" v-if="insFalse">
                            <el-form :model="insList" ref="ruleForm" label-width="150px" class="demo-ruleForm">
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="名称">
                                            <el-input v-model="insList.institution_name" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="编码">
                                            <el-input v-model="insList.institution_code" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>


                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="类别">
                                            <el-select v-model="insList.institution_type" filterable disabled
                                                placeholder="" style="width: 100%" @change="fangfa1" clearable>
                                                <el-option v-for="item in TypeList" :key="item.key" :label="item.value1"
                                                    :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="级别">
                                            <el-select v-model="insList.institution_grade_name" filterable disabled
                                                placeholder="" style="width: 100%" clearable>
                                                <el-option v-for="item in GardeList" :key="item.key"
                                                    :label="item.value1" :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="省份">
                                            <el-select v-model="insList.province_id" filterable disabled placeholder=""
                                                style="width: 100%" clearable>
                                                <el-option v-for="item in provinceList" :key="item.province_id"
                                                    :label="item.province_name" :value="item.province_id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="城市">
                                            <el-select v-model="insList.city_id" filterable disabled placeholder=""
                                                style="width: 100%" clearable>
                                                <el-option v-for="item in CityList" :key="item.city_id"
                                                    :label="item.city_name" :value="item.city_id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-form-item label="地址">
                                    <el-input v-model="insList.address" disabled></el-input>
                                </el-form-item>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="联系电话">
                                            <el-input v-model="insList.telephone" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="邮政编码">
                                            <el-input v-model="insList.postcode" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="官方网址">
                                            <el-input v-model="insList.website" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="所属经销商">

                                            <el-select v-model="insList.distributor_id" filterable disabled
                                                placeholder="" style="width: 100%" clearable>
                                                <el-option v-for="item in distributorList" :key="item.distributor_id"
                                                    :label="item.distributor_name" :value="item.distributor_id">
                                                </el-option>
                                            </el-select>

                                        </el-form-item>
                                    </el-col>
                                </el-row>


                                <el-form-item label="备注">
                                    <el-input type="textarea" :rows="3" v-model="insList.comments" placeholder=""
                                        disabled></el-input>
                                </el-form-item>


                            </el-form>

                        </div>
                        <div class="HcpClass1" style="margin-top: 20px;" v-if="hcpFalse">
                            <el-form ref="Hcplist" :model="Hcplist" label-width="150px">
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="所属科室/部门" prop="standard_dept">
                                            <el-select v-model="Hcplist.standard_dept" placeholder="  " filterable
                                                style="width: 100%" disabled>
                                                <el-option v-for="item in administrative" :key="item.key"
                                                    :label="item.value1" :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="科室挂牌名称" prop="department">
                                            <el-input v-model="Hcplist.department" placeholder=" " disabled></el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>
                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="姓名">
                                            <el-input v-model="Hcplist.name" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="性别">
                                            <el-select v-model="Hcplist.sex" style="width:100%" disabled>
                                                <el-option label="男" value="M"></el-option>
                                                <el-option label="女" value="F"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row>

                                    <el-col :span="12">
                                        <el-form-item label="职务">
                                            <el-select v-model="Hcplist.position" filterable style="width:100%" disabled
                                                placeholder="  ">
                                                <el-option v-for="item in jobtList" :key="item.key" :label="item.value1"
                                                    :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="职称">
                                            <el-select v-model="Hcplist.title" filterable style="width:100%" disabled
                                                placeholder="  ">
                                                <el-option v-for="item in prolist" :key="item.key" :label="item.value1"
                                                    :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>



                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="联系电话">
                                            <el-input v-model="Hcplist.phone" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="电子邮件">
                                            <el-input v-model="Hcplist.mali" disabled></el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="生日">
                                            <el-date-picker v-model="Hcplist.brithday" type="date"
                                                value-format="yyyy-MM-dd" placeholder="  " style="width: 100%" disabled>
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="爱好">
                                            <el-input v-model="Hcplist.hobby" placeholder="" disabled></el-input>
                                        </el-form-item>
                                    </el-col>


                                </el-row>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="主治病症">
                                            <el-input v-model="Hcplist.specialties" placeholder="" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="门诊时间">
                                            <el-input v-model="Hcplist.consulting_hours" placeholder=""
                                                disabled></el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="毕业院校">
                                            <el-input v-model="Hcplist.education" placeholder="" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="担任协会职务">
                                            <el-input v-model="Hcplist.fellowships" placeholder="" disabled></el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="专家讲者">
                                            <el-switch v-model="Hcplist.speaker" active-color="#13ce66" disabled>
                                            </el-switch>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="讲者级别">
                                            <el-select v-model="Hcplist.speaker_level" placeholder="  "
                                                style="width: 100%" disabled>
                                                <el-option v-for="item in prolist" :key="item.key" :label="item.value1"
                                                    :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>

                                </el-row>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="KOL">
                                            <el-switch v-model="Hcplist.kol" active-color="#13ce66" disabled>
                                            </el-switch>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="KOL级别">
                                            <el-select v-model="Hcplist.kol_level" placeholder="  " style="width: 100%"
                                                disabled>
                                                <el-option v-for="item in prolist" :key="item.key" :label="item.value1"
                                                    :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>

                                </el-row>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="在职">
                                            <el-switch v-model="Hcplist.status" active-color="#13ce66"
                                                active-value="ACTIVE" inactive-value="INACTIVE" disabled>
                                            </el-switch>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">

                                        <el-form-item label="HCP编码">
                                            <el-input v-model="Hcplist.hcp_code" placeholder="" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>



                            </el-form>
                        </div>
                        <div class="subjectList" style="margin-top: 20px;" v-if="storeFalse">
                            <el-form ref="storeList" :model="storeList" label-width="150px">

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="名称" prop="store_name">
                                            <el-input v-model="storeList.store_name" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="编码" prop="store_code">
                                            <el-input v-model="storeList.store_code" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="类别" prop="store_type">
                                            <el-select v-model="storeList.store_type" placeholder="" disabled
                                                style="width: 100%" @change="getGard" clearable>
                                                <el-option v-for="item in storeTypeList" :key="item.key"
                                                    :label="item.value1" :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="级别">
                                            <el-select v-model="storeList.retailstore_grade_name" placeholder=""
                                                disabled style="width: 100%" clearable>
                                                <el-option v-for="item in storeGardeList" :key="item.key"
                                                    :label="item.value1" :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="省份" prop="province_id">
                                            <el-select v-model="storeList.province_id" placeholder="" disabled
                                                style="width: 100%" clearable>
                                                <el-option v-for="item in provinceList" :key="item.province_id"
                                                    :label="item.province_name" :value="item.province_id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="城市" prop="city_name">
                                            <el-select v-model="storeList.city_name" placeholder="" disabled
                                                style="width: 100%" clearable>
                                                <el-option v-for="item in CityList" :key="item.city_id"
                                                    :label="item.city_name" :value="item.city_id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="所属医疗机构">

                                            <el-select v-model="storeList.institution_id" filterable placeholder=""
                                                disabled style="width: 100%" clearable>
                                                <el-option v-for="item in institutionList" :key="item.institution_id"
                                                    :label="item.institution_name" :value="item.institution_id">
                                                </el-option>
                                            </el-select>

                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="地址">
                                            <el-input v-model="storeList.address" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>


                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="联系电话">
                                            <el-input v-model="storeList.telephone" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="邮政编码">
                                            <el-input v-model="storeList.postcode" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="官方网址">
                                            <el-input v-model="storeList.website" placeholder="" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="所属经销商">

                                            <el-select v-model="storeList.distributor_id" filterable placeholder=""
                                                disabled style="width: 100%" clearable>
                                                <el-option v-for="item in storeDistributorList"
                                                    :key="item.distributor_id" :label="item.distributor_name"
                                                    :value="item.distributor_id">
                                                </el-option>
                                            </el-select>

                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-form-item label="备注">
                                    <el-input :rows="3" v-model="storeList.comments" placeholder="" disabled
                                        type="textarea"></el-input>
                                </el-form-item>


                            </el-form>
                        </div>
                        <div class="subjectList" style="margin-top: 20px;" v-if="disFalse">
                            <el-form ref="disList" :model="disList" label-width="150px">

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="名称" prop="distributor_name">
                                            <el-input v-model="disList.distributor_name" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="编码" prop="distributor_code">
                                            <el-input v-model="disList.distributor_code" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="类别" prop="distributor_type">
                                            <el-select v-model="disList.distributor_type" placeholder="" disabled
                                                style="width: 100%" @change="fangfa3" clearable>
                                                <el-option v-for="item in disTypeList" :key="item.key"
                                                    :label="item.value1" :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="级别">
                                            <el-select v-model="disList.distributor_grade_name" placeholder="" disabled
                                                style="width: 100%" clearable>
                                                <el-option v-for="item in disGardeList" :key="item.key"
                                                    :label="item.value1" :value="item.key">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="省份" prop="province_id">
                                            <el-select v-model="disList.province_id" placeholder="" disabled
                                                style="width: 100%" clearable>
                                                <el-option v-for="item in provinceList" :key="item.province_id"
                                                    :label="item.province_name" :value="item.province_id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="城市" prop="city_id">
                                            <el-select v-model="disList.city_id" placeholder="" disabled
                                                style="width: 100%" clearable>
                                                <el-option v-for="item in CityList" :key="item.city_id"
                                                    :label="item.city_name" :value="item.city_id">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-form-item label="地址">
                                    <el-input v-model="disList.address" disabled></el-input>
                                </el-form-item>

                                <el-row>
                                    <el-col :span="12">
                                        <el-form-item label="联系电话">
                                            <el-input v-model="disList.telephone" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="邮政编码">
                                            <el-input v-model="disList.postcode" disabled></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>


                                <el-form-item label="官方网址">
                                    <el-input v-model="disList.website" disabled></el-input>
                                </el-form-item>

                                <el-form-item label="备注">
                                    <el-input v-model="disList.comments" placeholder="" disabled
                                        type="textarea"></el-input>
                                </el-form-item>


                            </el-form>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="采集字段" name="second">
                        <div class="subjectList" style="margin-top: 20px;">
                            <el-form :ref="'list'+j" label-width="30%" v-for="(item,j) in extendedInfo" :model="item"
                                :key="item.field_id">
                                <el-col span="24" v-if="item.input_type == 'TEXT'">
                                    <el-form-item :label="item.label" prop="field_value"
                                        :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []">
                                        <el-input v-model="item.field_value" placeholder="请输入文本"
                                            :disabled="isdisable"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col span="24" v-else-if="item.input_type == 'NUMBER'">
                                    <el-form-item :label="item.label" prop="field_value"
                                        :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []">
                                        <el-input v-model="item.field_value" placeholder="请输入数字" type="number"
                                            :disabled="isdisable"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col span="24" v-else-if="item.input_type == 'DATE'">
                                    <el-form-item :label="item.label" prop="field_value"
                                        :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []">
                                        <el-date-picker v-model="item.field_value" type="date" placeholder="选择日期时间"
                                            style="width: 100%" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                            :disabled="isdisable">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col span="24" v-else-if="item.input_type == 'TRUE-FALSE'">
                                    <el-form-item :label="item.label">
                                        <el-switch v-model="item.field_value" active-color="#13ce66" active-value="T"
                                            inactive-value="F" :disabled="isdisable">
                                        </el-switch>
                                    </el-form-item>
                                </el-col>
                                <el-col span="24" v-else-if="item.input_type == 'LIST'">
                                    <el-form-item :label="item.label" prop="field_value"
                                        :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []">

                                        <el-cascader v-model="item.field_value" :options="item.listArray"
                                            style="width: 100%" filterable :show-all-levels="false"
                                            :disabled="item.readonly == 'T'"
                                            :props="{ multiple: item.multiple == 'T' ? true:false,checkStrictly: true }"
                                            clearable></el-cascader>
                                    </el-form-item>
                                </el-col>
                                <el-col span="24" v-else-if="item.input_type == 'TABLE'">
                                    <el-form-item :label="item.label" prop="field_value"
                                        :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []">
                                        <el-table :data="item.field_value" border style="width: 100%">
                                            <el-table-column type="index" label="序号" width="50">
                                            </el-table-column>
                                            <el-table-column prop="dept_name" label="标准科室"
                                                v-if="item.array_dept !== 'NONE'">
                                            </el-table-column>
                                            <el-table-column prop="product_name" label="产品"
                                                v-if="item.array_product !== 'NONE'">
                                            </el-table-column>
                                            <el-table-column prop="sku_name" label="SKU"
                                                v-if="item.array_product == 'SKU' && item.array_product !== 'NONE'">
                                            </el-table-column>
                                            <el-table-column prop="date_name" label="日期"
                                                v-if="item.array_date !== 'NONE' ">
                                            </el-table-column>
                                            <el-table-column prop="field_value" label="数值">
                                            </el-table-column>
                                            <el-table-column fixed="right" label="操作" width="80">
                                                <template slot-scope="scope">
                                                    <el-button @click="handleTableClick(scope.$index, scope.row,item)"
                                                        style="background-color: rgb(255, 153, 1);border: 1px solid rgb(255, 153, 1);color: #fff"
                                                        size="small">详情</el-button>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </el-form-item>
                                    <el-col :span="24" style="margin-bottom: 10px;">
                                        <el-button size="small" icon="el-icon-plus"
                                            style="float: left;margin-left: 30%;background-color:#6cc584;border: 1px solid #6cc584;color:#fff"
                                            v-if="!isdisable" @click="addNewTable(item)">添加新数据</el-button>
                                    </el-col>
                                    <el-col :span="24" v-if="item.isAddTable" id="addTableHcp"
                                        style="margin-left: 30%;width:70%;background: #edf3fb;border: 1px solid #ecdfe6;margin-bottom:10px;border-radius: 10px;">
                                        <el-col :span="14">
                                            <el-form ref="addTable1" :model="item.addTableList" style="margin-top:20px">
                                                <el-form-item label="标准科室" v-if="item.array_dept !== 'NONE'"
                                                    prop="dept_id" :rules="{ required: true, message: '标准科室不能为空'}">
                                                    <el-select v-model="item.addTableList.dept_id" placeholder="请选择标准科室"
                                                        style="width: 70%;float: right" clearable>
                                                        <el-option v-for="item in administrativeList" :key="item.key"
                                                            :label="item.value1" :value="item.key">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item label="产品" v-if="item.array_product !== 'NONE'"
                                                    prop="product_id" :rules="{ required: true, message: '产品不能为空'}">
                                                    <el-select v-model="item.addTableList.product_id"
                                                        placeholder="请选择产品" style="width: 70%;float: right"
                                                        @change="getSkuList(item)" clearable>
                                                        <el-option v-for="item in productList" :key="item.key"
                                                            :label="item.value1" :value="item.key">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item label="SKU"
                                                    v-if="item.array_product == 'SKU' && item.array_product !== 'NONE'"
                                                    prop="sku_id" :rules="{ required: true, message: 'SKU不能为空'}">
                                                    <el-select v-model="item.addTableList.sku_id" placeholder="请选择SKU"
                                                        style="width: 70%;float: right" clearable>
                                                        <el-option v-for="item in SkuList" :key="item.key"
                                                            :label="item.value1" :value="item.key">
                                                        </el-option>
                                                    </el-select>
                                                </el-form-item>
                                                <el-form-item label="日期"
                                                    v-if="item.array_date !== 'NONE' && item.array_date !== ''"
                                                    prop="info_date" :class="{home_star:true}"
                                                    :rules="{ required: true, message: '日期不能为空'}">
                                                    <el-date-picker v-model="item.addTableList.info_date" type="year"
                                                        style="width: 70%;float: right" format="yyyy年"
                                                        value-format="yyyy年" placeholder="选择年"
                                                        v-if="item.array_date == 'YEAR'">
                                                    </el-date-picker>
                                                    <quarter v-if="item.array_date == 'QUARTER'"
                                                        @child-event="parentEvent"
                                                        :defaultValue="item.addTableList.info_date"
                                                        :getValue="getQuarterValue" style="width: 70%;float: right">
                                                    </quarter>
                                                    <el-date-picker v-model="item.addTableList.info_date" type="month"
                                                        style="width: 70%;float: right" format="yyyy年MM月"
                                                        value-format="yyyy年MM月" placeholder="选择月"
                                                        v-if="item.array_date == 'MONTH'">
                                                    </el-date-picker>
                                                    <monthComponent v-if="item.array_date == 'WEEK'"
                                                        @week-event="parentWeekEvent"
                                                        :defaultValue="item.addTableList.info_date"
                                                        :getValue="getWeekValue" style="width: 70%;float: right">
                                                    </monthComponent>
                                                    <el-date-picker v-model="item.addTableList.info_date" type="date"
                                                        placeholder="选择日期" style="width: 70%;float: right"
                                                        format="yyyy年MM月dd日" value-format="yyyy年MM月dd日"
                                                        v-if="item.array_date == 'DAY'">
                                                    </el-date-picker>
                                                </el-form-item>
                                                <el-form-item label="数值" prop="field_value"
                                                    :rules="{ required: true, message: '数值不能为空'}">
                                                    <el-input v-model="item.addTableList.field_value"
                                                        placeholder="请输入数值" style="width: 70%;float: right"></el-input>
                                                </el-form-item>
                                            </el-form>

                                        </el-col>
                                        <el-col :span="10">
                                            <el-col style="margin-top:20px;">
                                                <el-button size="small"
                                                    style="float: left;margin-left: 40px;background-color:#588ede;border: 1px solid #588ede;color:#fff"
                                                    @click="addTableData(item)">保存</el-button>
                                                <el-button
                                                    style="float: left;margin-left: 20px;background-color:#e87570;border: 1px solid #e87570;color:#fff"
                                                    @click="delateTableData(item)" v-if="delateFalse"
                                                    size="small">删除</el-button>
                                                <el-button size="small"
                                                    style="float: left;margin-left: 20px;background-color:#e87570;border: 1px solid #e87570;color:#fff"
                                                    @click="cancelTableData(item)">取消</el-button>
                                            </el-col>

                                        </el-col>
                                    </el-col>
                                </el-col>
                                <el-col span="24" v-else-if="item.input_type == 'SELECT'">
                                    <el-form-item :label="item.label">
                                        <el-select v-model="item.field_value" @change="getExtendedInfoCity"
                                            :disabled="isdisable" style="width: 100%" placeholder="请选择">
                                            <el-option v-for="item in item.listArray" :key="item.key"
                                                :label="item.title" :value="item.key">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col span="24" v-else-if="item.input_type == 'SELECT_INS'">
                                    <el-form-item :label="item.label">
                                        <el-select v-model="item.field_value" style="width: 100%"
                                            @change="getExtendedInfoInsType" :disabled="isdisable" placeholder="请选择">
                                            <el-option v-for="item in item.listArray" :key="item.key"
                                                :label="item.title" :value="item.key">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col span="24" v-else-if="item.input_type == 'SELECT_STO'">
                                    <el-form-item :label="item.label">
                                        <el-select v-model="item.field_value" style="width: 100%"
                                            @change="getExtendedInfoStoType" :disabled="isdisable" placeholder="请选择">
                                            <el-option v-for="item in item.listArray" :key="item.key"
                                                :label="item.title" :value="item.key">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col span="24" v-else-if="item.input_type == 'SELECT_DIS'">
                                    <el-form-item :label="item.label">
                                        <el-select v-model="item.field_value" style="width: 100%"
                                            @change="getExtendedInfoDisType" :disabled="isdisable" placeholder="请选择">
                                            <el-option v-for="item in item.listArray" :key="item.key"
                                                :label="item.title" :value="item.key">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col span="24" v-else-if="item.input_type == 'SELECT2'">
                                    <el-form-item :label="item.label">
                                        <el-select v-model="item.field_value" style="width: 100%" :disabled="isdisable"
                                            placeholder="请选择">
                                            <el-option v-for="item in item.listArray" :key="item.key"
                                                :label="item.title" :value="item.key">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col span="24" v-else>
                                    <el-form-item :label="item.label" prop="field_value"
                                        :rules="item.mandatory == 'T' ? [{ required: true, message: item.label+'不能为空'}] : []">
                                        <el-input :rows="3" v-model="item.field_value" placeholder="请输入备注信息"
                                            type="textarea" :disabled="isdisable"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-form>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </el-dialog>


        <!--自定义表格-->
        <el-dialog id="customTableInfo" :visible.sync="dialogCustomTableDetails" width="900px" :show-close="false"
            style="vertical-align: center;">
            <div>
                <el-row style="padding-bottom: 20px;">
                    <el-col :span="12">
                        <div style="color: #3998F7;font-size: 26px">
                            {{name}}
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div align="right">
                            <el-button type="primary" size="small" @click.stop="saveCustomTable"
                                v-if="custom_select_tablerow.customTable_submit!='T' || add_custom_table">
                                保存
                            </el-button>
                            <el-button type="danger" size="small" @click.stop="close">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <el-row style="padding-bottom: 20px;">
                    <div class="subjectList" style="margin-top: 20px;">
                        <el-form label-width="20%">
                            <el-col :span="24">
                                <el-form-item label="辖区" prop="custom_terrtory_id">
                                    <el-select v-model="custom_terrtory_id" :disabled="data.inherit_task_id?true:false"
                                        style="width: 100%" placeholder="请选择"
                                        @change="(e) => changeCustomTerritoryId(e)">
                                        <el-option v-for="item in manager_no_submit_territory_array" :key="item.territory_id"
                                            :label="item.territory_name" :value="item.territory_id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-form>
                        <el-form :ref="'list'+j" label-width="20%" v-for="(item,j) in extendedInfo" :model="item"
                            :key="j">
                            <el-col :span="24" v-if="item.input_type == 'TEXT' && item.is_show!='F'">
                                <el-form-item :label="item.label" prop="field_value"
                                    :rules="(item.mandatory==='T' || item.primary_key==='T') ? [{ required: true, message: item.label+'不能为空'}] : []">
                                    <el-input v-model="item.field_value" :readonly="item.readonly==='T'" placeholder="请输入文本"
                                        ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" v-if="item.input_type == 'COMMENTS' && item.is_show!='F'">
                                <el-form-item :label="item.label" prop="field_value"
                                    :rules="(item.mandatory==='T' || item.primary_key==='T') ? [{ required: true, message: item.label+'不能为空'}] : []">
                                    <el-input v-model="item.field_value" :readonly="item.readonly==='T'" type="textarea" placeholder="请输入说明"
                                        ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" v-if="item.input_type == 'NUMBER' && item.is_show!='F'">
                                <el-form-item :label="item.label" prop="field_value"
                                    :rules="(item.mandatory==='T' || item.primary_key==='T') ? [{ required: true, message: item.label+'不能为空'}] : []">
                                    <el-input v-model="item.field_value" :readonly="item.readonly==='T'" placeholder="请输入数字" type="number"
                                        ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" v-if="item.input_type == 'DATE' && (item.field_name=='D_YSHYZKSJ' || item.field_name=='C_YSHYZKSJ') && item.is_show!='F'">
                                <el-form-item :label="item.label" prop="field_value" 
                                    :rules="(item.mandatory==='T' || item.primary_key==='T') ? [{ required: true, message: item.label+'不能为空'}] : []">
                                    <el-date-picker v-model="item.field_value" :readonly="item.readonly==='T'" type="month" placeholder="选择日期时间"
                                        style="width: 100%" format="yyyy-MM" value-format="yyyy-MM">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" v-else-if="item.input_type == 'DATE' && item.is_show!='F'">
                                <el-form-item :label="item.label" prop="field_value" 
                                    :rules="(item.mandatory==='T' || item.primary_key==='T') ? [{ required: true, message: item.label+'不能为空'}] : []">
                                    <el-date-picker v-model="item.field_value" :readonly="item.readonly==='T'" type="date" placeholder="选择日期时间"
                                        style="width: 100%" format="yyyy-MM-dd" value-format="yyyy-MM-dd">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" v-if="item.input_type == 'TRUE-FALSE' && item.is_show!='F'">
                                <el-form-item :label="item.label">
                                    <el-switch v-model="item.field_value" 
                                        :disabled="item.readonly==='T'" active-color="#13ce66" active-value="T" inactive-value="F" >
                                    </el-switch>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" v-if="item.input_type == 'ARRAY' && item.is_show!='F'">
                                <el-form-item :label="item.label"  v-if="item.multiple=='T'">
                                    <el-checkbox-group v-model="item.field_value" :disabled="item.readonly==='T'">
                                        <el-checkbox v-for="(sub_item, sub_index) in item.dictionary_array" :key="sub_index"
								                :label="sub_item.key" :name="sub_item.key">{{sub_item.title}}</el-checkbox>
                                    </el-checkbox-group>
                                </el-form-item>
                                <el-form-item :label="item.label"  v-else>
                                    <el-radio-group v-model="item.field_value" :disabled="item.readonly==='T'" @change="(e) => radioChange(e,item)">
                                        <el-radio v-for="(sub_item, sub_index) in item.dictionary_array" :key="sub_index"
								                :label="sub_item.key" :name="sub_item.key">{{sub_item.title}}</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <el-col ::span="24" v-if="item.input_type == 'LIST' && item.is_show!='F'">
                                <el-form-item v-if="item.field_name==='医院名称'||item.field_name==='INSTITUTION'" :label="item.label" prop="field_value"
                                    :rules="(item.mandatory==='T' || item.primary_key==='T') ? [{ required: true, message: item.label+'不能为空'}] : []">
                                    <el-select v-model="item.field_value"  :disabled="item.readonly==='T'" style="width: 100%"
                                        placeholder="请选择" @change="(e) => changeCustomInstitution(e,item)">
                                        <el-option v-for="item in customInstitutionList" :key="item.institution_id"
                                            :label="item.institution_name" :value="item.institution_id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item v-else-if="item.field_name==='商业名称'||item.field_name==='DISTRIBUTOR'" :label="item.label" prop="field_value"
                                    :rules="(item.mandatory==='T' || item.primary_key==='T') ? [{ required: true, message: item.label+'不能为空'}] : []">
                                    <el-select v-model="item.field_value"  :disabled="item.readonly==='T'" style="width: 100%"
                                        placeholder="请选择" @change="(e) => changeCustomDistributor(e,item)">
                                        <el-option v-for="item in customDistributorList" :key="item.distributor_id"
                                            :label="item.distributor_name" :value="item.distributor_id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item v-else-if="item.field_name==='产品名称'||item.field_name==='PRODUCT_SKU'" :label="item.label" prop="field_value"
                                    :rules="(item.mandatory==='T' || item.primary_key==='T') ? [{ required: true, message: item.label+'不能为空'}] : []">

                                    <el-select v-model="item.field_value"  :disabled="item.readonly==='T'" style="width: 100%"
                                        placeholder="请选择" @change="(e) => changeCustomProductSku(e,item)">
                                        <el-option v-for="item in customProductSkuList" :key="item.sku_id"
                                            :label="item.sku_name" :value="item.sku_id">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item v-else-if="item.field_name==='批号'||item.field_name==='BATCH_NO'" :label="item.label" prop="field_value"
                                    :rules="(item.mandatory==='T' || item.primary_key==='T') ? [{ required: true, message: item.label+'不能为空'}] : []">
                                    <el-select v-model="item.field_value"  :disabled="item.readonly==='T'" style="width: 100%"
                                        placeholder="请选择" allow-create filterable @change="(e) => changeCustomSkuBatch(e,item)">
                                        <el-option v-for="item in customProductSkuBatchList" :key="item.batch_no"
                                            :label="item.batch_no" :value="item.batch_no">
                                        </el-option>
                                    </el-select>
                                </el-form-item>

                                <!-- <el-form-item v-else-if="(item.field_name==='ZSZR'||item.field_name==='LCZR') && item.is_show!='F'"  -->
                                <el-form-item v-else-if="item.is_show!='F'" 
                                    :label="item.label" prop="field_value"
                                    :rules="(item.mandatory==='T' || item.primary_key==='T') ? [{ required: true, message: item.label+'不能为空'}] : []">
                                    <el-select v-model="item.field_value"  :disabled="item.readonly==='T'" style="width: 100%"
                                        placeholder="请选择" allow-create filterable @change="(e) => changeCustomField(e,item)">
                                        <el-option v-for="sub_item in item.dictionary_array" :key="sub_item.title"
                                            :label="sub_item.title" :value="sub_item.title">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" v-else-if="item.input_type == 'TABLE' && item.is_show!='F'">
                                <el-form-item :label="item.label" prop="field_value"
                                    :rules="(item.mandatory==='T' || item.primary_key==='T') ? [{ required: true, message: item.label+'不能为空'}] : []">
                                    <el-table :data="item.field_value" border style="width: 100%">
                                        <el-table-column type="index" label="序号" width="50">
                                        </el-table-column>
                                        <el-table-column prop="dept_name" label="标准科室"
                                            v-if="item.array_dept !== 'NONE'">
                                        </el-table-column>
                                        <el-table-column prop="product_name" label="产品"
                                            v-if="item.array_product !== 'NONE'">
                                        </el-table-column>
                                        <el-table-column prop="sku_name" label="SKU"
                                            v-if="item.array_product == 'SKU' && item.array_product !== 'NONE'">
                                        </el-table-column>
                                        <el-table-column prop="date_name" label="日期" v-if="item.array_date !== 'NONE' ">
                                        </el-table-column>
                                        <el-table-column prop="field_value" label="数值">
                                        </el-table-column>
                                        <el-table-column fixed="right" label="操作" width="80">
                                            <template slot-scope="scope">
                                                <el-button @click="handleTableClick(scope.$index, scope.row,item)"
                                                    style="background-color: rgb(255, 153, 1);border: 1px solid rgb(255, 153, 1);color: #fff"
                                                    size="small">详情</el-button>
                                            </template>
                                        </el-table-column>
                                    </el-table>
                                </el-form-item>
                                <el-col ::span="24" style="margin-bottom: 10px;">
                                    <el-button size="small" icon="el-icon-plus"
                                        style="float: left;margin-left: 30%;background-color:#6cc584;border: 1px solid #6cc584;color:#fff"
                                        v-if="!isdisable" @click="addNewTable(item)">添加新数据</el-button>
                                </el-col>
                                <el-col :span="24" v-if="item.isAddTable" id="addTableHcp"
                                    style="margin-left: 30%;width:70%;background: #edf3fb;border: 1px solid #ecdfe6;margin-bottom:10px;border-radius: 10px;">
                                    <el-col :span="14">
                                        <el-form ref="addTable1" :model="item.addTableList" style="margin-top:20px">
                                            <el-form-item label="标准科室" v-if="item.array_dept !== 'NONE'" prop="dept_id"
                                                :rules="{ required: true, message: '标准科室不能为空'}">
                                                <el-select v-model="item.addTableList.dept_id" placeholder="请选择标准科室"
                                                    style="width: 70%;float: right" clearable>
                                                    <el-option v-for="item in administrativeList" :key="item.key"
                                                        :label="item.value1" :value="item.key">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="产品" v-if="item.array_product !== 'NONE'"
                                                prop="product_id" :rules="{ required: true, message: '产品不能为空'}">
                                                <el-select v-model="item.addTableList.product_id" placeholder="请选择产品"
                                                    style="width: 70%;float: right" @change="getSkuList(item)"
                                                    clearable>
                                                    <el-option v-for="item in productList" :key="item.key"
                                                        :label="item.value1" :value="item.key">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="SKU"
                                                v-if="item.array_product == 'SKU' && item.array_product !== 'NONE'"
                                                prop="sku_id" :rules="{ required: true, message: 'SKU不能为空'}">
                                                <el-select v-model="item.addTableList.sku_id" placeholder="请选择SKU"
                                                    style="width: 70%;float: right" clearable>
                                                    <el-option v-for="item in SkuList" :key="item.key"
                                                        :label="item.value1" :value="item.key">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                            <el-form-item label="日期"
                                                v-if="item.array_date !== 'NONE' && item.array_date !== ''"
                                                prop="info_date" :class="{home_star:true}"
                                                :rules="{ required: true, message: '日期不能为空'}">
                                                <el-date-picker v-model="item.addTableList.info_date" type="year"
                                                    style="width: 70%;float: right" format="yyyy年" value-format="yyyy年"
                                                    placeholder="选择年" v-if="item.array_date == 'YEAR'">
                                                </el-date-picker>
                                                <quarter v-if="item.array_date == 'QUARTER'" @child-event="parentEvent"
                                                    :defaultValue="item.addTableList.info_date"
                                                    :getValue="getQuarterValue" style="width: 70%;float: right">
                                                </quarter>
                                                <el-date-picker v-model="item.addTableList.info_date" type="month"
                                                    style="width: 70%;float: right" format="yyyy年MM月"
                                                    value-format="yyyy年MM月" placeholder="选择月"
                                                    v-if="item.array_date == 'MONTH'">
                                                </el-date-picker>
                                                <monthComponent v-if="item.array_date == 'WEEK'"
                                                    @week-event="parentWeekEvent"
                                                    :defaultValue="item.addTableList.info_date" :getValue="getWeekValue"
                                                    style="width: 70%;float: right">
                                                </monthComponent>
                                                <el-date-picker v-model="item.addTableList.info_date" type="date"
                                                    placeholder="选择日期" style="width: 70%;float: right"
                                                    format="yyyy年MM月dd日" value-format="yyyy年MM月dd日"
                                                    v-if="item.array_date == 'DAY'">
                                                </el-date-picker>
                                            </el-form-item>
                                            <el-form-item label="数值" prop="field_value"
                                                :rules="{ required: true, message: '数值不能为空'}">
                                                <el-input v-model="item.addTableList.field_value" placeholder="请输入数值"
                                                    style="width: 70%;float: right"></el-input>
                                            </el-form-item>
                                        </el-form>

                                    </el-col>
                                    <el-col :span="10">
                                        <el-col style="margin-top:20px;">
                                            <el-button size="small"
                                                style="float: left;margin-left: 40px;background-color:#588ede;border: 1px solid #588ede;color:#fff"
                                                @click="addTableData(item)">保存</el-button>
                                            <el-button
                                                style="float: left;margin-left: 20px;background-color:#e87570;border: 1px solid #e87570;color:#fff"
                                                @click="delateTableData(item)" v-if="delateFalse"
                                                size="small">删除</el-button>
                                            <el-button size="small"
                                                style="float: left;margin-left: 20px;background-color:#e87570;border: 1px solid #e87570;color:#fff"
                                                @click="cancelTableData(item)">取消</el-button>
                                        </el-col>

                                    </el-col>
                                </el-col>
                            </el-col>
                            <el-col :span="24" v-else-if="item.input_type == 'SELECT'">
                                <el-form-item :label="item.label"
                                    :rules="(item.mandatory==='T' || item.primary_key==='T') ? [{ required: true, message: item.label+'不能为空'}] : []">
                                    <el-select v-model="item.field_value"  :disabled="item.readonly==='T'" @change="getExtendedInfoCity"
                                         style="width: 100%" placeholder="请选择">
                                        <el-option v-for="item in item.listArray" :key="item.key" :label="item.title"
                                            :value="item.key">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" v-else-if="item.input_type == 'SELECT_INS'">
                                <el-form-item :label="item.label">
                                    <el-select v-model="item.field_value"  :disabled="item.readonly==='T'" style="width: 100%"
                                        @change="getExtendedInfoInsType"  placeholder="请选择">
                                        <el-option v-for="item in item.listArray" :key="item.key" :label="item.title"
                                            :value="item.key">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" v-else-if="item.input_type == 'SELECT_STO'">
                                <el-form-item :label="item.label">
                                    <el-select v-model="item.field_value"  :disabled="item.readonly==='T'" style="width: 100%"
                                        @change="getExtendedInfoStoType"  placeholder="请选择">
                                        <el-option v-for="item in item.listArray" :key="item.key" :label="item.title"
                                            :value="item.key">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" v-else-if="item.input_type == 'SELECT_DIS'">
                                <el-form-item :label="item.label">
                                    <el-select v-model="item.field_value" :disabled="item.readonly==='T'" style="width: 100%"
                                        @change="getExtendedInfoDisType"  placeholder="请选择">
                                        <el-option v-for="item in item.listArray" :key="item.key" :label="item.title"
                                            :value="item.key">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24" v-else-if="item.input_type == 'SELECT2'">
                                <el-form-item :label="item.label">
                                    <el-select v-model="item.field_value" :disabled="item.readonly==='T'" style="width: 100%" 
                                        placeholder="请选择">
                                        <el-option v-for="item in item.listArray" :key="item.key" :label="item.title"
                                            :value="item.key">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <!-- <el-col :span="24" v-else>
                                <el-form-item :label="item.label" prop="field_value"
                                    :rules="(item.mandatory==='T' || item.primary_key==='T') ? [{ required: true, message: item.label+'不能为空'}] : []">
                                    <el-input :rows="3" v-model="item.field_value"  :readonly="item.readonly==='T'" placeholder="请输入" type="textarea"
                                        ></el-input>
                                </el-form-item>
                            </el-col> -->
                        </el-form>
                    </div>
                </el-row>
            </div>
        </el-dialog>

        
        <!--规则校验-->
        <el-dialog :visible.sync="dialogRules" width="800px" :show-close="false" style="vertical-align: center;">
                <el-row >
                    <el-col :span="12">
                        <div style="color: #3998F7;font-size: 20px">规则校验结果
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <div align="right">
                            <el-button type="danger" size="small" @click.stop="close">
                                关闭
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
                <el-tabs v-model="dialogModelRule">
                    <el-tab-pane label="周-规则1" name="week1_rule" v-if="rule_shows.week1_rule">
                        <el-card>
                            <el-row>
                                <el-col :span="24">
                                    <el-col :span="14">
                                        <div class="grid-content bg-purple-dark">
                                            <el-tag effect="dark">
                                                规则1
                                            </el-tag>
                                            <span style="color: #59a8f9;">【周】理论销售校验（批号）</span>
                                        </div>
                                    </el-col>
                                </el-col>
                                <el-col :span="23">
                                    <div style="margin-top: 20px;color: darkgray;font-size: 15px;line-height: 22px;">
                                        通过BI抽取医院上周采购数据计算后得出的医院上周理论销量小于0的异常情况（计算公式：该批号上周填报库存+上周该批号采购-本周填写的该批号的库存量<0） </div>
                                </el-col>
                            </el-row>
                        </el-card>
                        <el-card style="margin-top: 10px; background-color: #F6F8FA;">
                            <el-row>
                                <el-col :span="6" style="color: #000000;">
                                    上周填写数量
                                </el-col>
                                <el-col :span="18" style="color: #3998F7;">
                                    {{rule_values.week1_rule.field1}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="6" style="color: #000000;">
                                    期间采购(BI)
                                </el-col>
                                <el-col :span="18" style="color: #3998F7;">
                                    {{rule_values.week1_rule.field2}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="6" style="color: #000000;">
                                    本周填写数量
                                </el-col>
                                <el-col :span="18" style="color: #3998F7;">
                                    {{rule_values.week1_rule.field3}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="6" style="color: #000000;">
                                    周理论数量
                                </el-col>
                                <el-col :span="18" style="color: red;">
                                    {{rule_values.week1_rule.field4}}
                                </el-col>
                            </el-row>
                        </el-card>
                    </el-tab-pane>
                    <el-tab-pane label="周-规则2" name="week2_rule" v-if="rule_shows.week2_rule">
                        <el-card>
                            <el-row>
                                <el-col :span="24">
                                    <el-col :span="14">
                                        <div class="grid-content bg-purple-dark">
                                            <el-tag effect="dark">
                                                规则2
                                            </el-tag>
                                            <span style="color: #59a8f9;">【周】周累计销售异常校验(批号)</span>
                                        </div>
                                    </el-col>
                                </el-col>
                                <el-col :span="23">
                                    <div style="margin-top: 20px;color: darkgray;font-size: 15px;line-height: 22px;">
                                        每月从第三周起累计计算当月销售情况（计算公式：本月第一周为期初库存+期间内该批号医院采购流向-本周该批号的库存填报数量<0） </div>
                                </el-col>
                            </el-row>
                        </el-card>
                        <el-card style="margin-top: 10px; background-color: #F6F8FA;">
                            <el-row>
                                <el-col :span="6" style="color: #000000;">
                                    月度第一周填写数量
                                </el-col>
                                <el-col :span="18" style="color: #3998F7;">
                                    {{rule_values.week2_rule.field1}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="6" style="color: #000000;">
                                    期间采购(BI)
                                </el-col>
                                <el-col :span="18" style="color: #3998F7;">
                                    {{rule_values.week2_rule.field2}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="6" style="color: #000000;">
                                    本周填写数量
                                </el-col>
                                <el-col :span="18" style="color: #3998F7;">
                                    {{rule_values.week2_rule.field3}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="6" style="color: #000000;">
                                    周理论数量
                                </el-col>
                                <el-col :span="18" style="color: red;">
                                    {{rule_values.week2_rule.field4}}
                                </el-col>
                            </el-row>
                        </el-card>
                    </el-tab-pane>
                    <el-tab-pane label="周-规则3" name="week3_rule" v-if="rule_shows.week3_rule">
                        <el-card>
                            <el-row>
                                <el-col :span="24">
                                    <el-col :span="14">
                                        <div class="grid-content bg-purple-dark">
                                            <el-tag effect="dark">
                                                规则3
                                            </el-tag>
                                            <span style="color: #59a8f9;">【周】四分位法识别异常值校验(批号)</span>
                                        </div>
                                    </el-col>
                                </el-col>
                                <el-col :span="23">
                                    <div style="margin-top: 20px;color: darkgray;font-size: 15px;line-height: 22px;">
                                        本周所填报批号的理论销量大于过去52周该批号 周医院采购 最大值的异常情况</div>
                                </el-col>
                            </el-row>
                        </el-card>
                        <el-card style="margin-top: 10px; background-color: #F6F8FA;">
                            <el-row>
                                <el-col :span="8" style="color: #000000;">
                                    期初（指定采集任务）
                                </el-col>
                                <el-col :span="16" style="color: #3998F7;">
                                    {{rule_values.week3_rule.field1}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="8" style="color: #000000;">
                                    当周采购(BI)
                                </el-col>
                                <el-col :span="16" style="color: #3998F7;">
                                    {{rule_values.week3_rule.field2}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="8" style="color: #000000;">
                                    库存(本次填写的)
                                </el-col>
                                <el-col :span="16" style="color: #3998F7;">
                                    {{rule_values.week3_rule.field3}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="8" style="color: #000000;">
                                    理论销售量
                                </el-col>
                                <el-col :span="16" style="color: red;">
                                    {{rule_values.week3_rule.field4}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="8" style="color: #000000;">
                                    四分位极大值
                                </el-col>
                                <el-col :span="16" style="color: red;">
                                    {{rule_values.week3_rule.field5}}
                                </el-col>
                            </el-row>
                        </el-card>
                    </el-tab-pane>
                    <el-tab-pane label="周-规则4" name="week4_rule" v-if="rule_shows.week4_rule">
                        <el-card>
                            <el-row>
                                <el-col :span="24">
                                    <el-col :span="14">
                                        <div class="grid-content bg-purple-dark">
                                            <el-tag effect="dark">
                                                规则4
                                            </el-tag>
                                            <span style="color: #59a8f9;">【周】先进先出校验(批号)</span>
                                        </div>
                                    </el-col>
                                </el-col>
                                <el-col :span="23">
                                    <div style="margin-top: 20px;color: darkgray;font-size: 15px;line-height: 22px;">
                                        该医院存在批号倒置的情况 </div>
                                </el-col>
                            </el-row>
                        </el-card>
                        <el-card style="margin-top: 10px; background-color: #F6F8FA;">
                            <el-row>
                                <el-col :span="8" style="color: #000000;">
                                    上周该医院填写的批号
                                </el-col>
                                <el-col :span="16" style="color: #3998F7;">
                                    {{rule_values.week4_rule.field1}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="8" style="color: #000000;">
                                    上周该医院填写的批号所对应的日期
                                </el-col>
                                <el-col :span="16" style="color: #3998F7;">
                                    {{rule_values.week4_rule.field2}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="8" style="color: #000000;">
                                    当周该医院填写的批号
                                </el-col>
                                <el-col :span="16" style="color: #3998F7;">
                                    {{rule_values.week4_rule.field3}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="8" style="color: #000000;">
                                    当周该医院填写的批号对应的日期
                                </el-col>
                                <el-col :span="16" style="color: red;">
                                    {{rule_values.week4_rule.field4}}
                                </el-col>
                            </el-row>
                        </el-card>
                    </el-tab-pane>
                    <el-tab-pane label="周-规则5" name="week5_rule" v-if="rule_shows.week5_rule">
                        <el-card>
                            <el-row>
                                <el-col :span="24">
                                    <el-col :span="14">
                                        <div class="grid-content bg-purple-dark">
                                            <el-tag effect="dark">
                                                规则5
                                            </el-tag>
                                            <span style="color: #59a8f9;">【周】库存不动校验(批号)</span>
                                        </div>
                                    </el-col>
                                </el-col>
                                <el-col :span="23">
                                    <div style="margin-top: 20px;color: darkgray;font-size: 15px;line-height: 22px;">
                                        该医院的该批号库存连续四周不动销的异常情况（包括医院持续无库存的异常情况），可能存在库存风险</div>
                                </el-col>
                            </el-row>
                        </el-card>
                        <el-card style="margin-top: 10px; background-color: #F6F8FA;">
                            <el-row>
                                <el-col :span="6" style="color: #000000;">
                                    连续的周数
                                </el-col>
                                <el-col :span="18" style="color: #3998F7;">
                                    {{rule_values.week5_rule.field1}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="6" style="color: #000000;">
                                    前几周的填写数量
                                </el-col>
                                <el-col :span="18" style="color: #3998F7;">
                                    {{rule_values.week5_rule.field2}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="6" style="color: #000000;">
                                    本周填写的数量
                                </el-col>
                                <el-col :span="18" style="color: red;">
                                    {{rule_values.week5_rule.field3}}
                                </el-col>
                            </el-row>
                        </el-card>
                    </el-tab-pane>
                    
                    <el-tab-pane label="周-规则6" name="week6_rule" v-if="rule_shows.week6_rule">
                        <el-card>
                            <el-row>
                                <el-col :span="24">
                                    <el-col :span="14">
                                        <div class="grid-content bg-purple-dark">
                                            <el-tag effect="dark">
                                                规则6
                                            </el-tag>
                                            <span style="color: #59a8f9;">【周】无库存异常(机构)</span>
                                        </div>
                                    </el-col>
                                </el-col>
                                <el-col :span="23">
                                    <div style="margin-top: 20px;color: darkgray;font-size: 15px;line-height: 22px;">
                                        上周医院有采购但本次填报无库存</div>
                                </el-col>
                            </el-row>
                        </el-card>
                        <el-card style="margin-top: 10px; background-color: #F6F8FA;">
                            <el-row>
                                <el-col :span="6" style="color: #000000;">
                                    上周医院采购数量(BI)
                                </el-col>
                                <el-col :span="18" style="color: #3998F7;">
                                    {{rule_values.week6_rule.field1}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="6" style="color: #000000;">
                                    本周库存填写
                                </el-col>
                                <el-col :span="18" style="color: red;">
                                    {{rule_values.week6_rule.field2}}
                                </el-col>
                            </el-row>
                        </el-card>
                    </el-tab-pane>
                    <el-tab-pane label="周-规则7" name="week7_rule" v-if="rule_shows.week7_rule">
                        <el-card>
                            <el-row>
                                <el-col :span="24">
                                    <el-col :span="14">
                                        <div class="grid-content bg-purple-dark">
                                            <el-tag effect="dark">
                                                规则7
                                            </el-tag>
                                            <span style="color: #59a8f9;">【周】批号异常(批号)</span>
                                        </div>
                                    </el-col>
                                </el-col>
                                <el-col :span="23">
                                    <div style="margin-top: 20px;color: darkgray;font-size: 15px;line-height: 22px;">
                                        该批号在近一年的BI流向中不存在</div>
                                </el-col>
                            </el-row>
                        </el-card>
                        <el-card style="margin-top: 10px; background-color: #F6F8FA;">
                            <el-row>
                                <el-col :span="6" style="color: #000000;">
                                    机构
                                </el-col>
                                <el-col :span="18" style="color: #3998F7;">
                                    {{rule_values.week7_rule.field1}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="6" style="color: #000000;">
                                    批号
                                </el-col>
                                <el-col :span="18" style="color: #3998F7;">
                                    {{rule_values.week7_rule.field2}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="6" style="color: #000000;">
                                    本周填写数量
                                </el-col>
                                <el-col :span="18" style="color: #3998F7;">
                                    {{rule_values.week7_rule.field3}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="6" style="color: #000000;">
                                    流向数据(BI)
                                </el-col>
                                <el-col :span="18" style="color: red;">
                                    {{rule_values.week7_rule.field4}}
                                </el-col>
                            </el-row>
                        </el-card>
                    </el-tab-pane>
                    <el-tab-pane label="周-规则8" name="week8_rule" v-if="rule_shows.week8_rule">
                        <el-card>
                            <el-row>
                                <el-col :span="24">
                                    <el-col :span="14">
                                        <div class="grid-content bg-purple-dark">
                                            <el-tag effect="dark">
                                                规则8
                                            </el-tag>
                                            <span style="color: #59a8f9;">【周】期初校验(批号)</span>
                                        </div>
                                    </el-col>
                                </el-col>
                                <el-col :span="23">
                                    <div style="margin-top: 20px;color: darkgray;font-size: 15px;line-height: 22px;">
                                        首轮填报任务的填报数量大于该医院前3个月采购总量</div>
                                </el-col>
                            </el-row>
                        </el-card>
                        <el-card style="margin-top: 10px; background-color: #F6F8FA;">
                            <el-row>
                                <el-col :span="6" style="color: #000000;">
                                    前90天总采购(BI)
                                </el-col>
                                <el-col :span="18" style="color: #3998F7;">
                                    {{rule_values.week8_rule.field1}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="6" style="color: #000000;">
                                    本周填报库存
                                </el-col>
                                <el-col :span="18" style="color: #3998F7;">
                                    {{rule_values.week8_rule.field2}}
                                </el-col>
                            </el-row>
                        </el-card>
                    </el-tab-pane>

                    <el-tab-pane label="规则9" name="month1_rule" v-if="rule_shows.month1_rule">
                        <el-card>
                            <el-row>
                                <el-col :span="24">
                                    <el-col :span="14">
                                        <div class="grid-content bg-purple-dark">
                                            <el-tag effect="dark">
                                                规则1
                                            </el-tag>
                                            <span style="color: #59a8f9;">【月】月理论销售异常(批号)</span>
                                        </div>
                                    </el-col>
                                </el-col>
                                <el-col :span="23">
                                    <div style="margin-top: 20px;color: darkgray;font-size: 15px;line-height: 22px;">
                                        通过BI抽取医院上月采购数据计算后得出的医院上月理论销量小于0（该批号上个月期初填报库存+上月该批号采购-本月填写的该批号的库存量<0） </div>
                                </el-col>
                            </el-row>
                        </el-card>
                        <el-card style="margin-top: 10px; background-color: #F6F8FA;">
                            <el-row>
                                <el-col :span="6" style="color: #000000;">
                                    上周填写数量
                                </el-col>
                                <el-col :span="18" style="color: #3998F7;">
                                    {{rule_values.month1_rule.field1}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="6" style="color: #000000;">
                                    期间采购(BI)
                                </el-col>
                                <el-col :span="18" style="color: #3998F7;">
                                    {{rule_values.month1_rule.field2}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="6" style="color: #000000;">
                                    本周填写数量
                                </el-col>
                                <el-col :span="18" style="color: #3998F7;">
                                    {{rule_values.month1_rule.field3}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="6" style="color: #000000;">
                                    周理论数量
                                </el-col>
                                <el-col :span="18" style="color: red;">
                                    {{rule_values.month1_rule.field4}}
                                </el-col>
                            </el-row>
                        </el-card>
                    </el-tab-pane>
                    <el-tab-pane label="规则10" name="month2_rule" v-if="rule_shows.month2_rule">
                        <el-card class="padding">
                            <el-row>
                                <el-col :span="24">
                                    <el-col :span="14">
                                        <div class="grid-content bg-purple-dark">
                                            <el-tag effect="dark">
                                                规则10
                                            </el-tag>
                                            <span style="color: #59a8f9;">【月】先进先出异常(批号)</span>
                                        </div>
                                    </el-col>
                                </el-col>
                                <el-col :span="23">
                                    <div style="margin-top: 20px;color: darkgray;font-size: 15px;line-height: 22px;">
                                        现医院库存批号存在批号倒置</div>
                                </el-col>
                            </el-row>
                        </el-card>
                        <el-card style="margin-top: 10px; background-color: #F6F8FA;" class="padding">
                            <el-row>
                                <el-col :span="8" style="color: #000000;">
                                    上月该医院填写的批号
                                </el-col>
                                <el-col :span="16" style="color: #3998F7;">
                                    {{rule_values.month2_rule.field1}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="8" style="color: #000000;">
                                    上月该医院填写的批号所对应的日期
                                </el-col>
                                <el-col :span="16" style="color: #3998F7;">
                                    {{rule_values.month2_rule.field2}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="8" style="color: #000000;">
                                    当月该医院填写的批号
                                </el-col>
                                <el-col :span="16" style="color: red;">
                                    {{rule_values.month2_rule.field3}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="8" style="color: #000000;">
                                    当月该医院填写的批号对应的日期
                                </el-col>
                                <el-col :span="16" style="color: red;">
                                    {{rule_values.month2_rule.field4}}
                                </el-col>
                            </el-row>
                        </el-card>
                    </el-tab-pane>
                    
                    <el-tab-pane label="规则11" name="month3_rule" v-if="rule_shows.month3_rule">
                        <el-card class="padding">
                            <el-row>
                                <el-col :span="24">
                                    <el-col :span="14">
                                        <div class="grid-content bg-purple-dark">
                                            <el-tag effect="dark">
                                                规则11
                                            </el-tag>
                                            <span style="color: #59a8f9;">【月】无库存异常(机构)</span>
                                        </div>
                                    </el-col>
                                </el-col>
                                <el-col :span="23">
                                    <div style="margin-top: 20px;color: darkgray;font-size: 15px;line-height: 22px;">
                                        上月医院有采购但本次填报无库存</div>
                                </el-col>
                            </el-row>
                        </el-card>
                        <el-card style="margin-top: 10px; background-color: #F6F8FA;" class="padding">
                            <el-row>
                                <el-col :span="8" style="color: #000000;">
                                    上月至今的医院采购数量(BI)
                                </el-col>
                                <el-col :span="16" style="color: #3998F7;">
                                    {{rule_values.month3_rule.field1}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="8" style="color: #000000;">
                                    本月库存填写
                                </el-col>
                                <el-col :span="16" style="color:red;">
                                    {{rule_values.month3_rule.field2}}
                                </el-col>
                            </el-row>
                        </el-card>
                    </el-tab-pane>
                    
                    <el-tab-pane label="规则12" name="month4_rule" v-if="rule_shows.month4_rule">
                        <el-card class="padding">
                            <el-row>
                                <el-col :span="24">
                                    <el-col :span="14">
                                        <div class="grid-content bg-purple-dark">
                                            <el-tag effect="dark">
                                                规则12
                                            </el-tag>
                                            <span style="color: #59a8f9;">【月】无后续采购异常(机构)</span>
                                        </div>
                                    </el-col>
                                </el-col>
                                <el-col :span="23">
                                    <div style="margin-top: 20px;color: darkgray;font-size: 15px;line-height: 22px;">
                                        当月填报无库存但前两个月有库存，建议关注医院配送渠道变更风险</div>
                                </el-col>
                            </el-row>
                        </el-card>
                        <el-card style="margin-top: 10px; background-color: #F6F8FA;" class="padding">
                            <el-row>
                                <el-col :span="8" style="color: #000000;">
                                    N-1月采集数量
                                </el-col>
                                <el-col :span="16" style="color: #3998F7;">
                                    {{rule_values.month4_rule.field1}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="8" style="color: #000000;">
                                    N-2月采集数量
                                </el-col>
                                <el-col :span="16" style="color:#3998F7;">
                                    {{rule_values.month4_rule.field2}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="8" style="color: #000000;">
                                    本月填写数量
                                </el-col>
                                <el-col :span="16" style="color:red;">
                                    {{rule_values.month4_rule.field3}}
                                </el-col>
                            </el-row>
                        </el-card>
                    </el-tab-pane>
                    <el-tab-pane label="规则13" name="month5_rule" v-if="rule_shows.month5_rule">
                        <el-card class="padding">
                            <el-row>
                                <el-col :span="24">
                                    <el-col :span="14">
                                        <div class="grid-content bg-purple-dark">
                                            <el-tag effect="dark">
                                                规则13
                                            </el-tag>
                                            <span style="color: #59a8f9;">【月】销售异常(机构)</span>
                                        </div>
                                    </el-col>
                                </el-col>
                                <el-col :span="23">
                                    <div style="margin-top: 20px;color: darkgray;font-size: 15px;line-height: 22px;">
                                        计算得出该医院本月销售量远高于前两个月单月销售量</div>
                                </el-col>
                            </el-row>
                        </el-card>
                        <el-card style="margin-top: 10px; background-color: #F6F8FA;" class="padding">
                            <el-row>
                                <el-col :span="8" style="color: #000000;">
                                    本月填报库存
                                </el-col>
                                <el-col :span="16" style="color: #3998F7;">
                                    {{rule_values.month5_rule.field1}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="8" style="color: #000000;">
                                    月销售值(N月)
                                </el-col>
                                <el-col :span="16" style="color: #3998F7;">
                                    {{rule_values.month5_rule.field2}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="8" style="color: #000000;">
                                    月销售值(N-1月)
                                </el-col>
                                <el-col :span="16" style="color: red;">
                                    {{rule_values.month5_rule.field3}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="8" style="color: #000000;">
                                    月销售值(N-2月)
                                </el-col>
                                <el-col :span="16" style="color: red;">
                                    {{rule_values.month5_rule.field4}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="8" style="color: #000000;">
                                    设定的倍数
                                </el-col>
                                <el-col :span="16" style="color: red;">
                                    {{rule_values.month5_rule.field5}}
                                </el-col>
                            </el-row>
                        </el-card>
                    </el-tab-pane>
                    
                    <el-tab-pane label="规则14" name="month6_rule" v-if="rule_shows.month6_rule">
                        <el-card class="padding">
                            <el-row>
                                <el-col :span="24">
                                    <el-col :span="14">
                                        <div class="grid-content bg-purple-dark">
                                            <el-tag effect="dark">
                                                规则14
                                            </el-tag>
                                            <span style="color: #59a8f9;">【月】库存天数异常(机构)</span>
                                        </div>
                                    </el-col>
                                </el-col>
                                <el-col :span="23">
                                    <div style="margin-top: 20px;color: darkgray;font-size: 15px;line-height: 22px;">
                                        库存天数大于30天为异常</div>
                                </el-col>
                            </el-row>
                        </el-card>
                        <el-card style="margin-top: 10px; background-color: #F6F8FA;" class="padding">
                            <el-row>
                                <el-col :span="8" style="color: #000000;">
                                    前90天总采购(BI)
                                </el-col>
                                <el-col :span="16" style="color: #3998F7;">
                                    {{rule_values.month6_rule.field1}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="8" style="color: #000000;">
                                    本周填报库存
                                </el-col>
                                <el-col :span="16" style="color:red;">
                                    {{rule_values.month6_rule.field2}}
                                </el-col>
                            </el-row>
                        </el-card>
                    </el-tab-pane>
                    
                    <el-tab-pane label="规则15" name="month7_rule" v-if="rule_shows.month7_rule">
                        <el-card class="padding">
                            <el-row>
                                <el-col :span="24">
                                    <el-col :span="14">
                                        <div class="grid-content bg-purple-dark">
                                            <el-tag effect="dark">
                                                规则15
                                            </el-tag>
                                            <span style="color: #59a8f9;">【月】首月填报期初校验(批号)</span>
                                        </div>
                                    </el-col>
                                </el-col>
                                <el-col :span="23">
                                    <div style="margin-top: 20px;color: darkgray;font-size: 15px;line-height: 22px;">
                                        首轮填报任务的填报数量大于该医院前3个月采购总量</div>
                                </el-col>
                            </el-row>
                        </el-card>
                        <el-card style="margin-top: 10px; background-color: #F6F8FA;" class="padding">
                            <el-row>
                                <el-col :span="8" style="color: #000000;">
                                    前90天总采购(BI)
                                </el-col>
                                <el-col :span="16" style="color: #3998F7;">
                                    {{rule_values.month7_rule.field1}}
                                </el-col>
                            </el-row>
                            <el-row style="margin-top: 12px;">
                                <el-col :span="8" style="color: #000000;">
                                    本周填报库存
                                </el-col>
                                <el-col :span="16" style="color:red;">
                                    {{rule_values.month7_rule.field2}}
                                </el-col>
                            </el-row>
                        </el-card>
                    </el-tab-pane>

                    <el-tab-pane label="规则16" name="week9_rule" v-if="rule_shows.month7_rule">
                        <el-card class="padding">
                            <el-row>
                                <el-col :span="24">
                                    <el-col :span="14">
                                        <div class="grid-content bg-purple-dark">
                                            <el-tag effect="dark">
                                                规则16
                                            </el-tag>
                                            <span style="color: #59a8f9;">【月】近效期校验(批号)</span>
                                        </div>
                                    </el-col>
                                </el-col>
                                <el-col :span="23">
                                    <div style="margin-top: 20px;color: darkgray;font-size: 15px;line-height: 22px;">
                                        该批号产品有效期剩余{{rule_values.week9_rule.field1}}天</div>
                                </el-col>
                            </el-row>
                        </el-card>
                    </el-tab-pane>
                </el-tabs>
        </el-dialog>

    </div>
</template>

<script>
    import axios from "axios";
    import Swiper from 'swiper'
    import 'swiper/css/swiper.min.css'
    import 'swiper/js/swiper.min.js'
    import http from '../../../APIService/http'
    import pagination from '../../../components/pagination'
    import quarter from '../../../components/quarter'
    import monthComponent from '../../../components/monthComponent'
    import imgUrl from "../../../assets/images/mark_0.png";
    import moment from 'moment'
    import { Message } from "element-ui";
    export default {
        name: "zhunru_customCollectInfo",
        data() {
            return {
                loading: false,
                addTableList: {},
                delateFalse: false,
                institution_id: '',
                store_id: '',
                distributor_id: '',
                activeName: 'first',
                form: {
                    TerritoryList: '',
                },
                isInit: true,
                initArray: [],
                array: [],
                manager_no_submit_territory_array: [],
                checked: '',
                checked_staff_draft: true,
                checked_staff_submited: true,
                checked_manager_no_approved: true,
                checked_manager_submited: true,
                checked_manager_approved: true,
                territory_staff_draft_count: "0",
                territory_staff_submited_count: "0",
                territory_manager_submited_count: "0",
                territory_manager_approved_count: "0",
                territory_manager_no_approved_count: "0",
                territoryArray: [],
                selectEndPointTerritory: [],
                territory_name: '',
                territory_code: '',
                alias: null,
                imgarr: [require('../../../assets/images/wei.png'), require('../../../assets/images/xuan.png')],
                subTitle: '数据采集任务1',
                insTableData: [],
                hcpTableData: [],
                storeTableData: [],
                disTableData: [],
                customTableHeader: [],
                customTableData: [],
                customTableCurrentData: [],
                dialogDetails: false,
                dialogCustomTableDetails: false,
                dialogRules: false,
                name: '机构详情',
                activeName2: 'first',
                insFalse: false,
                hcpFalse: false,
                storeFalse: false,
                disFalse: false,
                extendedInfo: [],
                insList: {
                    institution_name: "",
                    institution_code: "",
                    institution_type: "",
                    institution_grade_name: "",
                    province_id: '',
                    city_id: "",
                    address: "",
                    telephone: "",
                    postcode: "",
                    website: "",
                    distributor_id: "",
                    comments: "",
                    status: "ACTIVE",
                },
                Hcplist: {
                    hcp_code: '',
                    status: 'ACTIVE',
                    kol_level: '',
                    kol: '',
                    speaker_level: '',
                    speaker: '',
                    fellowships: '',
                    education: '',
                    consulting_hours: '',
                    specialties: '',
                    hobby: '',
                    brithday: '',
                    mali: '',
                    phone: '',
                    title: '',
                    position: '',
                    sex: '',
                    name: '',
                    department: '',
                    standard_dept: ''
                },
                storeList: {
                    store_name: '',
                    store_code: '',
                    store_type: '',
                    retailstore_grade_name: '',
                    province_id: '',
                    city_name: '',
                    institution_id: '',
                    address: '',
                    telephone: '',
                    postcode: '',
                    website: '',
                    distributor_id: '',
                    comments: '',
                    status: 'ACTIVE'
                },
                disList: {
                    distributor_name: '',
                    distributor_code: '',
                    distributor_type: '',
                    distributor_grade_name: '',
                    province_id: '',
                    city_id: '',
                    address: '',
                    telephone: '',
                    postcode: '',
                    website: '',
                    comments: '',

                },
                TypeList: [],
                GardeList: [],
                provinceList: [],
                CityList: [],
                distributorList: [],
                disTypeList: [],
                disGardeList: [],
                storeTypeList: [],
                storeGardeList: [],
                institutionList: [],
                storeDistributorList: [],
                administrative: [],
                jobtList: [],
                prolist: [],
                task_id: '',
                page: {
                    current: 1,
                    size: 5,
                    total: 0
                },
                reference_obj: 'INSTITUTION',
                fieldArray: [],
                administrativeList: [],
                productList: [],
                SkuList: [],
                TerritoryList: [],
                taskTerritoryList: [],
                is_staff_false: true,
                data: {},
                hcp_id: '',
                isdisable: true,
                clientObj: {},
                search_keyword:"",
                search_institution_options:[],
                search_institution_name_list:[],
                selectCustomTableRow: [],
                customInstitutionList: [],
                customDistributorList: [],
                customProductSkuList: [],
                customProductSkuBatchList: [],
                custom_institution_id: "",
                custom_sku_id: "",
                custom_terrtory_id: "",
                custom_select_tablerow: {
                    customTable_submit: "F",
                    customTable_staff_submit: "F"

                },
                add_custom_table: false,

                dialogModelRule:"week1_rule",
                rule_shows:{
                    week1_rule:false,
                    week2_rule:false,
                    week3_rule:false,
                    week4_rule:false,
                    week5_rule:false,
                    week6_rule:false,
                    week7_rule:false,
                    week8_rule:false,
                    month1_rule:false,
                    month2_rule:false,
                    month3_rule:false,
                    month4_rule:false,
                    month5_rule:false,
                    month6_rule:false,
                    month7_rule:false,
                },
                rule_values:{
                    week1_rule:{},
                    week2_rule:{},
                    week3_rule:{},
                    week4_rule:{},
                    week5_rule:{},
                    week6_rule:{},
                    week7_rule:{},
                    week8_rule:{},
                    month1_rule:{},
                    month2_rule:{},
                    month3_rule:{},
                    month4_rule:{},
                    month5_rule:{},
                    month6_rule:{},
                    month7_rule:{},
                },
                rule_result:[],
				D_CJTGXTSX_array:[]
            }
        },
        components: {
            pagination,
            quarter,
            monthComponent
        },
        created() {
            if (this.$route.params) {
                console.log("---params:",this.$route.params)
                this.data = this.$route.params
                this.subTitle = this.$route.params.task_name
                this.task_id = this.$route.params.task_id
                if (this.$route.params.writeField == 'T') {
                    this.isdisable = false
                }

            } else {

                let customCollectInfo = JSON.parse(localStorage.getItem('zhunru_customCollectInfo'))
                this.data = customCollectInfo
                this.subTitle = customCollectInfo.task_name
                this.task_id = customCollectInfo.task_id
                if (customCollectInfo.writeField == 'T') {
                    this.isdisable = false
                }
            }
            if (this.data.reference_obj[0] === "CUSTOMTABLE") {
                this.activeName = 'five';
            }
            this.clientObj = this.$store.getters.getClient
            
            this.getDictionaryListByZR_CJTGXTSX();
            this.getItitutionTypeList()
            this.getProvinceList()
            this.getCity()
            this.getStandardDeptList()
            this.getJobtList()
            this.getProList()
            this.getRetailstoreTypeList()
            this.getDistributorTypeList()

            if (this.$store.getters.getUser.role == 'staff') {
                this.is_staff_false = false
                this.getApprovalListByTerritoryId()
            } else {
                this.getTerritoryList()
            }
        },
        methods: {
            getExtendedInfoCity(a) {
                this.extendedInfo.forEach(item => {
                    if (item.field_id == 'city_id') {
                        item.field_value = ''
                    }
                })
                this.getCityList(a)
            },
            getExtendedInfoInsType(a) {
                this.extendedInfo.forEach(item => {
                    if (item.field_id == 'institution_grade' && item.reference_obj == 'INSTITUTION') {
                        item.field_value = ''
                    }
                })
                this.getInsGardeList(a)
            },
            getExtendedInfoStoType(a) {
                this.extendedInfo.forEach(item => {
                    if (item.field_id == 'retailstore_grade' && item.reference_obj == 'RETAILSTORE') {
                        item.field_value = ''
                    }
                })
                this.getStoGardeList(a)
            }, getExtendedInfoDisType(a) {
                this.extendedInfo.forEach(item => {
                    if (item.field_id == 'distributor_grade' && item.reference_obj == 'DISTRIBUTOR') {
                        item.field_value = ''
                    }
                })
                this.getDisGardeList(a)
            },
            async getInsGardeList(a) {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    key: a

                }
                await http.post('/wapi/Collect/getInsGardeList', data).then(res => {
                    if (res.success) {
                        this.extendedInfo.forEach(item => {
                            if (item.field_id == 'institution_grade') {
                                item.listArray = res.data
                            }
                        })
                    } else {
                        Message.error(res.message);
                    }
                })
            },

            async getStoGardeList(a) {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    key: a

                }
                await http.post('/wapi/Collect/getStoGardeList', data).then(res => {
                    if (res.success) {
                        this.extendedInfo.forEach(item => {
                            if (item.field_id == 'retailstore_grade') {
                                item.listArray = res.data
                            }
                        })
                    } else {
                        Message.error(res.message);
                    }
                })
            },

            async getDisGardeList(a) {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    key: a

                }
                await http.post('/wapi/Collect/getDisGardeList', data).then(res => {
                    if (res.success) {
                        this.extendedInfo.forEach(item => {
                            if (item.field_id == 'distributor_grade') {
                                item.listArray = res.data
                            }
                        })
                    } else {
                        Message.error(res.message);
                    }
                })
            },

            async getCityList(a) {

                let data = {
                    province_id: a,
                    tenant_id: this.$store.getters.getUser.tenant_id,
                }
                await http.post('/wapi/Collect/getCityList', data).then(res => {

                    if (res.success) {
                        this.extendedInfo.forEach(item => {
                            if (item.field_id == 'city_id') {
                                item.listArray = res.data
                            }
                        })
                    } else {
                        Message.error(res.message);
                    }
                })
            },
            agree() {
                this.ApprovedAccount()
            },
            refuse() {
                this.DeniedAccount()
            },

            async getDictionaryListByZR_CJTGXTSX() {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    category: "ZR_CJTGXTSX"
                }
                let self = this
                await http.post('/wapi/v1/getDictionaryListByCategory', data).then(res => {

                    if (res.success) {
                        self.D_CJTGXTSX_array = res.data

                    } else {
                        Message.error(res.message);
                    }

                })
            },
            // 机构
            async getItitutionTypeList() {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                }

                let self = this
                await http.post('/wapi/Institution/getItitutionTypeList', data).then(res => {

                    if (res.success) {
                        self.TypeList = res.data

                    } else {
                        Message.error(res.message);
                    }
                })
            },
            fangfa1(b) {
                this.insList.institution_grade_name = ''
                this.getItitutionGardeList(b)
            },
            async getItitutionGardeList(b) {

                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    key: b

                }

                let self = this
                await http.post('/wapi/Institution/getItitutionGardeList', data).then(res => {

                    if (res.success) {
                        self.GardeList = res.data

                    } else {
                        Message.error(res.message);
                    }
                })
            },
            getProvinceList() {
                let user = this.$store.getters.getUser
                let data = {
                    tenant_id: user.tenant_id
                }
                http.post('/wapi/Province/getProvinceList', data).then(res => {
                    if (res.success) {
                        this.provinceList = res.data
                    }
                })
            },
            getCity() {
                let user = this.$store.getters.getUser
                let data = {
                    tenant_id: user.tenant_id,
                }
                http.post('/wapi/City/getCityList1', data).then(res => {
                    if (res.success) {
                        this.CityList = res.data
                    }
                })
            },
            getDistributorList(a) {
                let user = this.$store.getters.getUser
                let data = {
                    tenant_id: user.tenant_id,
                    institution_id: a
                }
                http.post('/wapi/Collect/getDistributorList', data).then(res => {
                    if (res.success) {
                        this.distributorList = res.data

                    }
                })
            },

            // hcp
            async getStandardDeptList() {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                }

                let self = this
                await http.post('/wapi/Institution/getStandardDeptList', data).then(res => {

                    if (res.success) {
                        self.administrative = res.data

                    } else {
                        Message.error(res.message);
                    }
                })
            },
            async getJobtList() {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                }

                let self = this
                await http.post('/wapi/Institution/getJobtList', data).then(res => {

                    if (res.success) {
                        self.jobtList = res.data

                    } else {
                        Message.error(res.message);
                    }
                })
            },
            async getProList() {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                }

                let self = this
                await http.post('/wapi/Institution/getProList', data).then(res => {

                    if (res.success) {
                        self.prolist = res.data

                    } else {
                        Message.error(res.message);
                    }
                })
            },

            // 门店
            async getInstitution(a) {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    store_id: a
                }
                await http.post('/wapi/Collect/getInstitution', data).then(res => {

                    if (res.success) {
                        this.institutionList = res.data

                    } else {
                        Message.error(res.message);
                    }
                })
            },
            async getStoreDistributorList(a) {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    store_id: a
                }
                await http.post('/wapi/Collect/getStoreDistributorList', data).then(res => {

                    if (res.success) {
                        this.storeDistributorList = res.data

                    } else {
                        Message.error(res.message);
                    }
                })
            },
            async getRetailstoreTypeList() {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                }

                let self = this
                await http.post('/wapi/Retailstore/getRetailstoreTypeList', data).then(res => {

                    if (res.success) {
                        self.storeTypeList = res.data

                    } else {
                        Message.error(res.message);
                    }
                })
            },
            getGard(b) {
                this.storeList.retailstore_grade_name = ''
                this.getRetailstoreGardeList(b)
            },
            async getRetailstoreGardeList(b) {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    key: b
                }
                let self = this
                await http.post('/wapi/Retailstore/getRetailstoreGardeList', data).then(res => {

                    if (res.success) {
                        self.storeGardeList = res.data

                    } else {
                        Message.error(res.message);
                    }
                })
            },

            // 经销商
            fangfa3(b) {
                this.disList.distributor_grade_name = ''
                this.getDistributorGardeList(b)
            },
            async getDistributorTypeList() {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                }

                let self = this
                await http.post('/wapi/Distributor/getDistributorTypeList', data).then(res => {

                    if (res.success) {
                        self.disTypeList = res.data

                    } else {
                        Message.error(res.message);
                    }
                })
            },
            async getDistributorGardeList(b) {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    key: b
                }

                let self = this
                await http.post('/wapi/Distributor/getDistributorGardeList', data).then(res => {

                    if (res.success) {
                        self.disGardeList = res.data

                    } else {
                        Message.error(res.message);
                    }
                })
            },
            delateTableData(item) {
                for (let i = 0; i < item.field_value.length; i++) {
                    if (item.addTableList.id == item.field_value[i].id) {
                        item.field_value.splice(i, 1)
                        item.isAddTable = false
                        this.$forceUpdate()
                    }
                }
            },
            parentEvent(data) {
                this.addTableList.info_date = data
            },
            getQuarterValue(a, b) {
                this.QUARTER = a + 'Q' + b
            },
            getWeekValue(a, b, c) {
                let month = b.toString()
                this.WEEK = a + month + 'W' + c

            },
            parentWeekEvent(data) {
                this.addTableList.info_date = data
            },
            handleTableClick(index, row, item) {
                item.isAddTable = true
                this.delateFalse = true
                this.getSkuList(row.product_id)
                item.addTableList = {
                    id: row.id,
                    dept_id: row.dept_id,
                    dept_name: row.dept_name,
                    product_id: row.product_id,
                    product_name: row.product_name,
                    sku_id: row.sku_id,
                    sku_name: row.sku_name,
                    info_date: row.info_date,
                    date_name: row.date_name,
                    field_value: row.field_value,
                }
                this.$forceUpdate()

            },
            addNewTable(item) {

                this.delateFalse = false
                item.isAddTable = true
                item.addTableList = {
                    id: '',
                    dept_id: '',
                    dept_name: '',
                    product_id: '',
                    product_name: '',
                    sku_id: '',
                    sku_name: '',
                    info_date: '',
                    date_name: '',
                    field_value: ''
                }
                this.addTableList = {}
                this.addTableList = item.addTableList
                this.$forceUpdate()
            },
            getAdministrativeList() {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    category: 'STANDARD_DEPT'
                }
                http.post('/wapi/Institution/getAdministrativeList', data).then(res => {
                    if (res.success) {
                        this.administrativeList = res.data

                    }
                })

            },
            getProductList() {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                }
                http.post('/wapi/Institution/getProductList', data).then(res => {
                    if (res.success) {
                        this.productList = res.data

                    }
                })

            },
            getSkuList(item) {
                let product_id = ''
                if (item instanceof Object) {
                    product_id = item.addTableList.product_id
                    item.addTableList.sku_id = ''
                    item.addTableList.sku_name = ''
                } else {
                    product_id = item
                }

                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    product_id: product_id
                }
                http.post('/wapi/Institution/getSkuList', data).then(res => {
                    if (res.success) {
                        this.SkuList = res.data
                    }
                })

            },
            changeQUARTER(item) {
                this.QUARTER = ''
                var arr = item.split('-')
                if (arr[1] < 4) {
                    this.QUARTER = arr[0] + 'Q1'
                } else if (arr[1] > 3 && arr[1] < 7) {
                    this.QUARTER = arr[0] + 'Q2'
                } else if (arr[1] > 6 && arr[1] < 9) {
                    this.QUARTER = arr[0] + 'Q3'
                } else {
                    this.QUARTER = arr[0] + 'Q4'
                }



            },
            changeWEEK(item) {
                this.WEEK = ''
                var arr = item.split('-')
                if (arr[2] < 8) {
                    this.WEEK = arr[0] + arr[1] + 'W1'
                } else if (arr[2] > 7 && arr[2] < 15) {
                    this.WEEK = arr[0] + arr[1] + 'W2'
                } else if (arr[2] > 14 && arr[2] < 22) {
                    this.WEEK = arr[0] + arr[1] + 'W3'
                } else {
                    this.WEEK = arr[0] + arr[1] + 'W4'
                }

            },
            getUuid() {
                var s = [];
                var hexDigits = "0123456789abcdef";
                for (var i = 0; i < 36; i++) {
                    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
                }
                s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
                s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
                s[8] = s[13] = s[18] = s[23] = "-";

                var uuid = s.join("");
                return uuid

            },
            addTableData(item) {

                this.$refs["addTable1"][0].validate(valid => {
                    if (!valid) {
                        return false
                    } else {

                        if (this.QUARTER) {
                            item.addTableList.info_date = this.QUARTER
                            let arr = this.QUARTER.split('Q')
                            let year = arr[0].slice(0, 4)
                            item.addTableList.date_name = `${year}年第${arr[1]}季度`
                        }
                        if (this.WEEK) {
                            item.addTableList.info_date = this.WEEK
                            let arr = this.WEEK.split('W')
                            let year = arr[0].slice(0, 4)
                            let month = arr[0].slice(4)
                            item.addTableList.date_name = `${year}年${month}月第${arr[1]}周`

                        }

                        if (item.addTableList.id) {//编辑
                            for (let i = 0; i < item.field_value.length; i++) {
                                if (item.addTableList.id == item.field_value[i].id) {
                                    item.field_value[i].dept_id = item.addTableList.dept_id
                                    if (item.addTableList.dept_id) {
                                        for (let j = 0; j < this.administrativeList.length; j++) {
                                            if (item.addTableList.dept_id == this.administrativeList[j].key) {
                                                item.addTableList.dept_name = this.administrativeList[j].value1
                                                break
                                            }
                                        }
                                    }
                                    item.field_value[i].dept_name = item.addTableList.dept_name
                                    item.field_value[i].product_id = item.addTableList.product_id
                                    if (item.addTableList.product_id) {
                                        for (let j = 0; j < this.productList.length; j++) {
                                            if (item.addTableList.product_id == this.productList[j].key) {
                                                item.addTableList.product_name = this.productList[j].value1
                                                break
                                            }
                                        }
                                    }
                                    item.field_value[i].product_name = item.addTableList.product_name
                                    item.field_value[i].sku_id = item.addTableList.sku_id
                                    if (item.addTableList.sku_id) {
                                        for (let j = 0; j < this.SkuList.length; j++) {
                                            if (item.addTableList.sku_id == this.SkuList[j].key) {
                                                item.addTableList.sku_name = this.SkuList[j].value1
                                                break
                                            }
                                        }
                                    }
                                    item.field_value[i].sku_name = item.addTableList.sku_name
                                    item.field_value[i].info_date = item.addTableList.info_date
                                    item.field_value[i].date_name = item.addTableList.date_name
                                    item.field_value[i].field_value = item.addTableList.field_value
                                }
                            }
                        }
                        else {//新增
                            item.addTableList.id = this.getUuid()
                            if (item.addTableList.dept_id) {
                                for (let i = 0; i < this.administrativeList.length; i++) {
                                    if (item.addTableList.dept_id == this.administrativeList[i].key) {
                                        item.addTableList.dept_name = this.administrativeList[i].value1
                                    }
                                }
                            } if (item.addTableList.product_id) {
                                for (let i = 0; i < this.productList.length; i++) {
                                    if (item.addTableList.product_id == this.productList[i].key) {
                                        item.addTableList.product_name = this.productList[i].value1
                                    }
                                }
                            } if (item.addTableList.sku_id) {
                                for (let i = 0; i < this.SkuList.length; i++) {
                                    if (item.addTableList.sku_id == this.SkuList[i].key) {
                                        item.addTableList.sku_name = this.SkuList[i].value1
                                    }
                                }
                            }
                            if (this.QUARTER) {
                                item.addTableList.info_date = this.QUARTER
                                let arr = this.QUARTER.split('Q')
                                let year = arr[0].slice(0, 4)
                                item.addTableList.date_name = `${year}年第${arr[1]}季度`
                            } else if (this.WEEK) {
                                item.addTableList.info_date = this.WEEK
                                let arr = this.WEEK.split('W')
                                let year = arr[0].slice(0, 4)
                                let month = arr[0].slice(4)
                                item.addTableList.date_name = `${year}年${month}月第${arr[1]}周`

                            } else {
                                item.addTableList.date_name = item.addTableList.info_date
                            }
                            item.field_value.push(item.addTableList)
                        }


                        item.isAddTable = false
                        item.addTableList = {
                            id: '',
                            dept_id: '',
                            dept_name: '',
                            product_id: '',
                            product_name: '',
                            sku_id: '',
                            sku_name: '',
                            info_date: '',
                            date_name: '',
                            field_value: ''
                        }
                        this.$forceUpdate()


                    }
                })

            },
            cancelTableData(item) {
                item.isAddTable = false
                item.addTableList = {
                    id: '',
                    dept_id: '',
                    dept_name: '',
                    product_id: '',
                    product_name: '',
                    sku_id: '',
                    sku_name: '',
                    info_date: '',
                    date_name: '',
                    field_value: ''
                }
                this.$forceUpdate()

            },

            handleClick(row) {

                this.extendedInfo = []
                this.activeName2 = 'first'
                this.getCollectionFieldList(row)

                if (row.reference_obj == 'INSTITUTION') {
                    this.insFalse = true
                    this.hcpFalse = false
                    this.storeFalse = false
                    this.disFalse = false
                    this.name = '机构详情'
                    this.institution_id = row.institution_id
                    this.getInstitutionInfo(row.institution_id)
                    this.getDistributorList(row.institution_id)
                } else if (row.reference_obj == 'HCP') {
                    this.insFalse = false
                    this.hcpFalse = true
                    this.storeFalse = false
                    this.disFalse = false
                    this.name = 'HCP详情'
                    this.institution_id = row.institution_id
                    this.hcp_id = row.hcp_id
                    this.getHcpInfo(row.hcp_id)

                } else if (row.reference_obj == 'RETAILSTORE') {
                    this.insFalse = false
                    this.hcpFalse = false
                    this.storeFalse = true
                    this.disFalse = false
                    this.name = '门店详情'
                    this.store_id = row.store_id
                    this.getInstitution(row.store_id)
                    this.getStoreDistributorList(row.store_id)
                    this.getStoreList(row.store_id)

                } else if (row.reference_obj == 'DISTRIBUTOR') {
                    this.insFalse = false
                    this.hcpFalse = false
                    this.storeFalse = false
                    this.disFalse = true
                    this.name = '经销商详情'
                    this.distributor_id = row.distributor_id
                    this.getDistributorInfo(row.distributor_id)

                }

            },
            async handleCustomTableClick(row) {
                for (let i = 0; i < this.extendedInfo.length; i++) {
                    if(typeof this.$refs["list"+i].resetFields =="function")
                    {
                        this.$refs["list"+i].resetFields();
                    }
                }
                this.name = '自定义表格'
                this.custom_institution_id = "";
                this.custom_sku_id = "";
                this.selectCustomTableRow = row;
                this.add_custom_table = false;
                this.custom_terrtory_id = this.selectCustomTableRow[0].territory_id;

                let territory_obj = this.array.find(e => e.territory_id == this.custom_terrtory_id);
                console.log("-------territory_obj--------")
                console.log(territory_obj)
                if (territory_obj) {
                    this.custom_select_tablerow.customTable_staff_submit = territory_obj.customTable_staff_submit
                    this.custom_select_tablerow.customTable_approve = territory_obj.customTable_approve
                    this.custom_select_tablerow.customTable_submit = territory_obj.customTable_submit
                    this.manager_no_submit_territory_array = [territory_obj];
                }

                await this.getInstutionsListByTerritoryId();
                await this.getDistributorListByTerritoryId();
                await this.getCustomProductSkuList();
                await this.getCustomProductSkuBatchList();

                await this.getCustomTableCollectionFieldList()
                this.dialogCustomTableDetails = true
            },
            async handleCustomAdd() {
                for (let i = 0; i < this.extendedInfo.length; i++) {
                    if(typeof this.$refs["list"+i].resetFields =="function")
                    {
                        this.$refs["list"+i].resetFields();
                    }
                }

                this.name = '自定义表格'
                this.selectCustomTableRow = [];
                this.add_custom_table = true;
                this.custom_institution_id = "";
                this.custom_sku_id = "";
                // this.manager_no_submit_territory_array = this.array.filter(e=>e.customTable_submit==="F" && e.customTable_staff_submit=='T');
                
                if(this.is_staff_false)
                {
                    console.log("----handleCustomAdd------------------")
                    this.manager_no_submit_territory_array = this.array.filter(e=>e.customTable_submit!=="F"&& e.customTable_staff_submit=='T');
                }else{
                    this.manager_no_submit_territory_array = this.array.filter(e=> e.customTable_staff_submit=='F');
                }
                await this.getCustomTableCollectionFieldList();
                this.selectCustomTableRow = this.extendedInfo;
                this.dialogCustomTableDetails = true
            },
            getInstitutionInfo(a) {
                let user = this.$store.getters.getUser
                let data = {
                    tenant_id: user.tenant_id,
                    institution_id: a

                }
                http.post('/wapi/Institution/getInstitutionInfo', data).then(res => {
                    if (res.success) {

                        this.insList = {
                            institution_name: res.data[0].institution_name,
                            institution_code: res.data[0].institution_code,
                            institution_type: res.data[0].institution_type,
                            institution_grade_name: res.data[0].institution_grade_name,
                            province_id: res.data[0].province_id,
                            city_id: res.data[0].city_id,
                            address: res.data[0].address,
                            telephone: res.data[0].telephone,
                            postcode: res.data[0].postcode,
                            website: res.data[0].website,
                            distributor_id: res.data[0].distributor_id,
                            comments: res.data[0].comments,
                            status: res.data[0].status,
                        }


                    }
                })

            },
            getHcpInfo(a) {
                let user = this.$store.getters.getUser
                let data = {
                    tenant_id: user.tenant_id,
                    hcp_id: a
                }
                http.post('/wapi/Collect/getHcpInfo', data).then(res => {
                    if (res.success) {

                        this.Hcplist = {
                            hcp_code: res.data[0].hcp_code,
                            status: res.data[0].status,
                            kol_level: res.data[0].kol_level,
                            kol: res.data[0].kol,
                            speaker_level: res.data[0].speaker_level,
                            speaker: res.data[0].speaker,
                            fellowships: res.data[0].fellowships,
                            education: res.data[0].education,
                            consulting_hours: res.data[0].consulting_hours,
                            specialties: res.data[0].specialties,
                            hobby: res.data[0].hobby,
                            brithday: res.data[0].birthday,
                            mali: res.data[0].email,
                            phone: res.data[0].office_phone,
                            title: res.data[0].pro_title_id,
                            position: res.data[0].job_title_id,
                            sex: res.data[0].gender,
                            name: res.data[0].hcp_name,
                            department: res.data[0].department,
                            standard_dept: res.data[0].standard_dept
                        }

                    }
                })
            },
            getStoreList(a) {
                let user = this.$store.getters.getUser
                let data = {
                    tenant_id: user.tenant_id,
                    store_id: a
                }
                let self = this
                http.post('/wapi/Retailstore/getRetailstoreInfo', data).then(res => {
                    if (res.success) {
                        self.storeList.address = res.data[0].address
                        self.storeList.city_id = res.data[0].city_id
                        self.storeList.city_name = res.data[0].city_name
                        self.storeList.comments = res.data[0].comments
                        self.storeList.lat = res.data[0].lat
                        self.storeList.lng = res.data[0].lng
                        self.storeList.location_id = res.data[0].location_id
                        self.storeList.postcode = res.data[0].postcode
                        self.storeList.province_id = res.data[0].province_id
                        self.storeList.province_name = res.data[0].province_name
                        self.storeList.retailstore_grade = res.data[0].retailstore_grade
                        self.storeList.retailstore_grade_name = res.data[0].retailstore_grade_name
                        self.storeList.province_name = res.data[0].province_name
                        self.storeList.store_id = res.data[0].store_id
                        self.storeList.store_name = res.data[0].store_name
                        self.storeList.store_type = res.data[0].store_type
                        self.storeList.store_type_name = res.data[0].store_type_name
                        self.storeList.tenant_id = res.data[0].tenant_id
                        self.storeList.website = res.data[0].website
                        self.storeList.telephone = res.data[0].telephone
                        self.storeList.store_code = res.data[0].store_code
                    }
                })

            },
            getDistributorInfo(a) {
                let user = this.$store.getters.getUser
                let data = {
                    tenant_id: user.tenant_id,
                    distributor_id: a
                }
                let self = this
                http.post('/wapi/Distributor/getDistributorInfo', data).then(res => {
                    if (res.success) {
                        self.disList.address = res.data[0].address
                        self.disList.city_id = res.data[0].city_id
                        self.disList.city_name = res.data[0].city_name
                        self.disList.comments = res.data[0].comments
                        self.disList.distributor_grade = res.data[0].distributor_grade
                        self.disList.distributor_grade_name = res.data[0].distributor_grade_name
                        self.disList.distributor_id = res.data[0].distributor_id
                        self.disList.distributor_name = res.data[0].distributor_name
                        self.disList.distributor_type = res.data[0].distributor_type
                        self.disList.distributor_type_name = res.data[0].distributor_type_name
                        self.disList.lat = res.data[0].lat
                        self.disList.lng = res.data[0].lng
                        self.disList.location_id = res.data[0].location_id
                        self.disList.postcode = res.data[0].postcode
                        self.disList.province_id = res.data[0].province_id
                        self.disList.province_name = res.data[0].province_name
                        self.disList.telephone = res.data[0].telephone
                        self.disList.tenant_id = res.data[0].tenant_id
                        self.disList.website = res.data[0].website
                        self.disList.distributor_code = res.data[0].distributor_code
                    }
                })
            },
            async getCollectionFieldList(row) {
                let loading1 = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)',

                });
                try {
                    let data = {
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        task_id: this.task_id,
                        institution_id: row.institution_id,
                        hcp_id: row.hcp_id,
                        store_id: row.store_id,
                        distributor_id: row.distributor_id,
                        reference_obj: row.reference_obj
                    }
                    await http.post('/wapi/Collect/getCollectionFieldList', data).then(res => {
                        if (res.success) {

                            this.extendedInfo = res.data
                            this.getAdministrativeList()
                            this.getProductList()
                            if (this.extendedInfo.length > 0) {
                                this.extendedInfo.forEach(item => {
                                    if (item.input_type === "LIST" && item.multiple === 'T' && item.field_value.indexOf('|') == -1 && item.field_value !== '') {
                                        item.field_value = [item.field_value]
                                    }
                                    if (item.input_type === "LIST" && item.field_value.indexOf('|') !== -1) {
                                        item.field_value = item.field_value.split('|')
                                    }
                                    if (item.input_type === "LIST" && item.multiple === 'T' && item.field_value === '') {
                                        item.field_value = []
                                    }
                                    if (item.input_type === "TABLE" && item.field_value !== '') {
                                        item.field_value = JSON.parse(item.field_value)
                                    }
                                    if (item.input_type === "TABLE" && item.field_value === '') {
                                        item.field_value = []
                                    }
                                    if (item.input_type === "TRUE-FALSE" && item.field_value === "") {
                                        item.field_value = 'F'
                                    }


                                })
                            }



                        }
                        this.dialogDetails = true
                        loading1.close()
                    })
                } catch (e) {
                    loading1.close()
                }

            },
            handleTabClick(tab, event) {

                this.page = {
                    current: 1,
                    size: 5,
                    total: 0
                }
                if (tab.label == '机构') {
                    this.reference_obj = 'INSTITUTION'
                } else if (tab.label == 'HCP') {
                    this.reference_obj = 'HCP'
                } else if (tab.label == '门店') {
                    this.reference_obj = 'RETAILSTORE'
                } else if (tab.label == '经销商') {
                    this.reference_obj = 'DISTRIBUTOR'
                } else if (tab.label == '自定义表格') {
                    this.reference_obj = 'CUSTOMTABLE'
                }

                if (this.reference_obj == 'CUSTOMTABLE') {
                    if (this.territoryArray.length > 0) {
                        this.getCustomTableList();
                    }
                } else {
                    if (this.territoryArray.length > 0) {
                        this.getInstitutionList()
                    }
                }
            },
            async getCustomTableCollectionFieldList() {
                console.log(11)

                this.loading = true;
                console.log(22)
                try {
                    console.log(33)
                    let data = {
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        // user_id: this.selectCustomTableRow.length > 0 ? this.selectCustomTableRow[0].created_by : this.$store.getters.getUser.user_id,
                        task_id: this.task_id,
                        row_id: this.selectCustomTableRow.length > 0 ? this.selectCustomTableRow[0].row_id : ""
                    }
                    console.log(data)
                    await http.post('/crm/web/collection/getCollectionCustomTableFieldList', data).then(res => {
                        console.log(res)
                        if (res.success) {

                            this.extendedInfo = res.data
                            if (this.extendedInfo.length > 0) {
                                this.extendedInfo.forEach(item => {
                                    if (item.input_type === "TRUE-FALSE" && !item.field_value) {
                                        item.field_value = 'T'
                                    }
                                    if (item.input_type === "TRUE-FALSE" && item.field_name=="有效"){
                                        item.readonly="F"
                                    }
                                    if (item.input_type === "ARRAY"  && item.multiple == 'T' && item.field_value){
                                        item.field_value = item.field_value.split(",")
                                    }
								    this.setZhunruShow(item, false);
                                })
                            }
                            console.log(this.extendedInfo)
                        }
                        this.loading = false;
                    })
                } catch (e) {
                    console.log(e)
                    this.loading = false;
                }
            },

			setZhunruShow(item, check) {
				if (item.field_name == "BNDSFZKYSH") {
					let obj = this.extendedInfo.find(e => e.field_name == "YSHYJZKSJ_S")
					let obj1 = this.extendedInfo.find(e => e.field_name == "YSHYJZKSJ_E")
					let obj2 = this.extendedInfo.find(e => e.field_name == "YSHSJZKSJ")
					let obj3 = this.extendedInfo.find(e => e.field_name == "YSHTLFW")
					if (item.field_value == "Z01") {
						if (obj) {
							obj["is_show"] = 'T';
							if (check) {
								obj.field_value = "";
							}
						}
						if (obj1) {
							obj1["is_show"] = 'T';
							if (check) {
								obj1.field_value = "";
							}
						}
						if (obj2) {
							obj2["is_show"] = 'T';
							if (check) {
								obj2.field_value = "";
							}
						}
						if (obj3) {
							obj3["is_show"] = 'T';
							if (check) {
								obj3.field_value = [];
							}
						}
					} else {
						if (obj) {
							obj["is_show"] = 'F';
							if (check) {
								obj.field_value = "";
							}
						}
						if (obj1) {
							obj1["is_show"] = 'F';
							if (check) {
								obj1.field_value = "";
							}
						}
						if (obj2) {
							obj2["is_show"] = 'F';
							if (check) {
								obj2.field_value = "";
							}
						}
						if (obj3) {
							obj3["is_show"] = 'F';
							if (check) {
								obj3.field_value = [];
							}
						}
					}
				} else if (item.field_name == "TD_STATUS") {

					let obj = this.extendedInfo.find(e => e.field_name == "TD_DATE")
					let obj2 = this.extendedInfo.find(e => e.field_name == "TD_TYPE")
					let obj3 = this.extendedInfo.find(e => e.field_name == "ZSZR")
					let obj4 = this.extendedInfo.find(e => e.field_name == "LCZR")
					if (item.field_value == "Z01") {
						if (obj) {
							obj["is_show"] = 'T';
							if (check) {
								obj.field_value = "";
							}
						}
						if (obj2) {
							obj2["is_show"] = 'T';
							if (check) {
								obj2.field_value = '';
							}
						}
					} else {
						if (obj) {
							obj["is_show"] = 'F';
							if (check) {
								obj.field_value = "";
							}
						}
						if (obj2) {
							obj2["is_show"] = 'F';
							if (check) {
								obj2.field_value = '';
							}
						}
					}
					if (obj3) {
						obj3["is_show"] = 'F';
						if (check) {
							obj3.field_value = "";
						}
					}
					if (obj4) {
						obj4["is_show"] = 'F';
						if (check) {
							obj4.field_value = '';
						}
					}
				}else if (item.field_name == "TD_TYPE") {
                    let obj2 = this.extendedInfo.find(e => e.field_name == "ZSZR")
					let obj3 = this.extendedInfo.find(e => e.field_name == "LCZR")
					if (item.field_value == "Z01") {
						if (obj2) {
							obj2["is_show"] = 'T';
							if (check) {
								obj2.field_value = '';
							}
						}
						if (obj3) {
							obj3["is_show"] = 'F';
							if (check) {
								obj3.field_value = '';
							}
						}
					} else if (item.field_value == "Z02") {
						if (obj2) {
							obj2["is_show"] = 'F';
							if (check) {
								obj2.field_value = '';
							}
						}
						if (obj3) {
							obj3["is_show"] = 'T';
							if (check) {
								obj3.field_value = '';
							}
						}
					}
                }else if (item.field_name == "D_YSHXGXX") {
                    console.log(item.field_value)
					let obj = this.extendedInfo.find(e => e.field_name == "D_YSHYZKSJ")
					let obj1 = this.extendedInfo.find(e => e.field_name == "D_YSHSJZKSJ")
					if (item.field_value == "Z01" || item.field_value == "Z02" || item.field_value == "Z03") {
						if (obj) {
							obj.is_show = 'T';
							if (check) {
								obj.field_value = "";
							}
						}
						if (obj1) {
							obj1.is_show = 'T';
							if (check) {
								obj1.field_value = "";
							}
						}
					} else {
						if (obj) {
							obj.is_show = 'F';
							if (check) {
								obj.field_value = "";
							}
						}
						if (obj1) {
							obj1.is_show = 'F';
							if (check) {
								obj1.field_value = "";
							}
						}
					}
                    console.log(this.extendedInfo)
				} else if (item.field_name == "D_CJTGXTSX") {
					let obj = this.extendedInfo.find(e => e.field_name == "D_YWYTXSYFK")
					console.log("obj", obj)
					let isShow = this.D_CJTGXTSX_array.find(e=>e.value1==item.field_value);
					if (isShow) {
						if (obj) {
							obj["is_show"] = 'T';
							if (check) {
								obj.field_value = "";
							}
						}
					} else {
						if (obj) {
							obj["is_show"] = 'F';
							if (check) {
								obj.field_value = "";
							}
						}
					}
				}else if (item.field_name == "C_YSHQXXZS") {
					let obj = this.extendedInfo.find(e => e.field_name == "C_YSHYZKSJ")
					let obj1 = this.extendedInfo.find(e => e.field_name == "C_YSHSJZKSJ")
					if (item.field_value == "Z01" || item.field_value == "Z02" || item.field_value == "Z03") {
						if (obj) {
							obj["is_show"] = 'T';
							if (check) {
								obj.field_value = "";
							}
						}
						if (obj1) {
							obj1["is_show"] = 'T';
							if (check) {
								obj1.field_value = "";
							}
						}
					} else {
						if (obj) {
							obj["is_show"] = 'F';
							if (check) {
								obj.field_value = "";
							}
						}
						if (obj1) {
							obj1["is_show"] = 'F';
							if (check) {
								obj1.field_value = "";
							}
						}
					}
				}  else if (item.field_name == "D_ZRZT") {
					let obj = this.extendedInfo.find(e => e.field_name == "D_WZRYY")
					if (item.field_value == "Z03") {
						if (obj) {
							obj["is_show"] = 'T';
							if (check) {
								obj.field_value = "";
							}
						}
					} else {
						if (obj) {
							obj["is_show"] = 'F';
							if (check) {
								obj.field_value = "";
							}
						}
					}
				}
                this.$forceUpdate();

			},
            // 改变页码信息
            changePageClick(page, size) {
                if (page) {
                    this.page.current = page
                }
                if (size) {
                    this.page.size = size
                }
                this.getInstitutionList()
            }, // 改变页码信息
            changePageCustomTableClick(page, size) {
                if (page) {
                    this.page.current = page
                }
                if (size) {
                    this.page.size = size
                }
                console.log((this.page.current - 1) * this.page.size, (this.page.current) * this.page.size)
                this.customTableCurrentData = []
                this.customTableCurrentData = this.customTableData.slice((this.page.current - 1) * this.page.size, (this.page.current) * this.page.size);
                console.log(this.customTableCurrentData)
            },
            getInstitutionList() {
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let data = {
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        user_id: this.$store.getters.getUser.user_id,
                        task_id: this.task_id,
                        territory_id: this.territoryArray,
                        limit: this.page.size,
                        offset: this.page.current - 1,
                        reference_obj: this.reference_obj
                    }
                    http.post('/wapi/Collect/getInstitutionFieldList', data).then(res => {
                        if (res.success) {

                            res.data.array.forEach(item => {
                                if (item.timestamp) {
                                    item.timestamp = moment(item.timestamp).format('YYYY年MM月DD日')
                                }
                            })
                            if (this.reference_obj == 'INSTITUTION') {
                                this.insTableData = res.data.array
                            } else if (this.reference_obj == 'HCP') {
                                this.hcpTableData = res.data.array
                            } else if (this.reference_obj == 'RETAILSTORE') {
                                this.storeTableData = res.data.array
                            } else if (this.reference_obj == 'DISTRIBUTOR') {
                                this.disTableData = res.data.array
                            }

                            this.fieldArray = []
                            this.fieldArray = res.data.fieldArray
                            this.page.total = res.data.arrayCont.length


                            loading.close()
                        }
                    })

                } catch (e) {
                    loading.close()
                }
            },
            getCustomTableList() {
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    this.reference_obj = "CUSTOMTABLE"
                    let data = {
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        user_id: this.$store.getters.getUser.user_id,
                        task_id: this.task_id,
                        territory_id: this.territoryArray,
                        reference_obj: this.reference_obj,
                        is_staff: this.is_staff_false ? "F" : "T"
                    }
                    http.post('/crm/web/collection/getCollectionCustomTableList', data).then(res => {
                        if (res.success) {
                            res.data.customTable_array.forEach(item => {
                                if (item.timestamp) {
                                    item.timestamp = moment(item.timestamp).format('YYYY年MM月DD日')
                                }
                            })
                            this.resetCustomTable(res.data.array, res.data.customTable_array);

                            this.fieldArray = []
                            this.fieldArray = res.data.fieldArray


                            loading.close()
                        }
                    })

                } catch (e) {
                    console.log(e)
                    loading.close()
                }
            },
            resetCustomTable(head_array, body_array) {
                head_array.push({
                    field_name:"规则校验结果",
                    field_id:"rule"
                })
                this.customTableHeader = head_array;

                // let map = [];
                // let row_array = [];
                // body_array.forEach(item => {
                //     if (map.indexOf(item.row_id) < 0) {
                //         row_array.push({
                //             row_id: item.row_id,
                //             list: [item]
                //         })
                //         map.push(item.row_id);
                //     } else {
                //         row_array.forEach(obj => {
                //             if (obj.row_id == item.row_id) {
                //                 obj.list.push(item)
                //             }
                //         })
                //     }
                // })
                // row_array = row_array.sort(this.compare("row_id"))
                // console.log("-----row-array----")
                // console.log(row_array);
                this.customTableData = []
                // for (let row_obj of row_array) {
                //     let row_column_list = row_obj.list;

                //     let result_row_obj = []
                //     for (let _item_head of head_array) {
                //         let _temp_result_row_obj = row_column_list.find(e => e.field_id === _item_head.field_id);

                //         // result_row_obj.push(_temp_result_row_obj)
                //         if (_temp_result_row_obj) {
                //             // result_row_obj[_item_head.field_id] = _temp_result_row_obj;
                //             result_row_obj.push(_temp_result_row_obj)
                //         } else {
                //         // result_row_obj[_item_head.field_id] = null;
                //             result_row_obj.push({
                //                 field_value: "",
                //                 row_id: row_obj.row_id
                //             })
                //         }

                //     }
                //     if(this.search_keyword){
                //         if(result_row_obj.find(e=>e.field_value==this.search_keyword)){
                //             this.customTableData.push(result_row_obj)
                //         }
                //     }else{
                //         this.customTableData.push(result_row_obj)
                //     }
                // }
                for(let row_obj_array of body_array){
                    if(this.search_keyword){
                        if(row_obj_array.find(e=>e.field_value==this.search_keyword)){
                            this.customTableData.push(row_obj_array)
                        }
                    }else{
                        this.customTableData.push(row_obj_array)
                    }
                }
                this.page.total = this.customTableData.length
                this.customTableCurrentData = this.customTableData.slice((this.page.current - 1) * this.page.size, (this.page.current) * this.page.size);
            },
            compare(property) {
                return function (obj1, obj2) {
                    var value1 = obj1[property];
                    var value2 = obj2[property];
                    return value1 - value2; // 升序
                };
            },
            getCustomTableScopeFieldValue(row, index) {
                console.log(row,index)
                let _temp_result_row_obj = this.customTableData[index].find(e => e.field_id === row.field_id);

                if (_temp_result_row_obj) {
                    if(_temp_result_row_obj.field_name=="有效")
                    {
                        if(_temp_result_row_obj.field_value=='F')
                        {
                            return "否"
                        }
                        return "是";
                    }
                    return _temp_result_row_obj.field_value;
                } else { //  前段添加列 规则验证
                    
                    let rule_html="";
                    if(this.data.group_code && 
                        (this.data.group_code=="ZR_DAILY_TASK" 
                        || this.data.group_code=="ZR_MONTH_TASK" )) //准入
                    { 
                        if(row.field_id=="rule"){
                            let temp_rule=[];
                            let row_column_list_obj=this.customTableData[index][0];
                            console.log("--row_column_list_obj-------")
                            console.log(row_column_list_obj)
                            if(row_column_list_obj.rule_week1_passed=="F")
                                rule_html=rule_html+'<tag class="rule_tag">提单情况不一致</tag>';
                        }
                    }
                    return rule_html;
                }
            },

            async getInstutionsListByTerritoryId() {
                try {
                    let tenant_id = this.$store.getters.getUser.tenant_id;
                    let territory_id = this.add_custom_table ? this.custom_terrtory_id : this.selectCustomTableRow[0].territory_id;
                    let month = this.add_custom_table ? moment().format("YYYYMM") : moment(this.selectCustomTableRow[0].created).format("YYYYMM");
                    let params = {
                        tenant_id: tenant_id,
                        territory_id: territory_id,
                        month: month,
                    };
                    await http.post('/wapi/Collect/getInstitutionListByTerritoryId', params).then(res => {
                        if (res.success) {
                            this.customInstitutionList = res.data
                        }
                    })
                } catch (e) {
                    console.log(e)
                }
            },

            async getDistributorListByTerritoryId(add_territory_id) {
                try {
                    let tenant_id = this.$store.getters.getUser.tenant_id;
                    let territory_id = this.add_custom_table ? this.custom_terrtory_id : this.selectCustomTableRow[0].territory_id;
                    let month = this.add_custom_table ? moment().format("YYYYMM") : moment(this.selectCustomTableRow[0].created).format("YYYYMM");
                    let params = {
                        tenant_id: tenant_id,
                        territory_id: territory_id,
                        month: month,
                    };
                    await http.post('/wapi/Collect/getDistributorListByTerritoryId', params).then(res => {
                        if (res.success) {
                            this.customDistributorList = res.data;
                        }
                    })
                } catch (e) {
                    console.log(e)
                }
            },
            async getCustomProductSkuList() {
                try {
                    let tenant_id = this.$store.getters.getUser.tenant_id;
                    let territory_id = this.add_custom_table ? this.custom_terrtory_id : this.selectCustomTableRow[0].territory_id;
                    let month = this.add_custom_table ? moment().format("YYYYMM") : moment(this.selectCustomTableRow[0].created).format("YYYYMM");;
                    let params = {
                        tenant_id: tenant_id,
                        territory_id: territory_id,
                        institution_id:this.custom_institution_id,
                        month: month,
                    };
                    await http.post('/crm/product/sku/getSkuListByTerrtoryIdAndInstitutionId', params).then(res => {
                        if (res.success) {
                            this.customProductSkuList = res.data;
                        }
                    })

                } catch (e) {
                    console.log(e)
                }
            },
            async getCustomProductSkuBatchList() {
                try {
                    let tenant_id = this.$store.getters.getUser.tenant_id;
                    let institution_obj = this.selectCustomTableRow.find(e => e.institution_id != "" && e.institution_id != null);
                    let sku_obj = this.selectCustomTableRow.find(e => e.sku_id != "" && e.sku_id != null);
                    let institution_id = this.custom_institution_id ? this.custom_institution_id : institution_obj.institution_id;
                    let sku_id = this.custom_sku_id ? this.custom_sku_id : sku_obj.sku_id;
                    if (institution_id && sku_id) {
                        console.log(sku_obj)
                        let params = {
                            tenant_id: tenant_id,
                            institution_id: this.custom_institution_id ? this.custom_institution_id : institution_obj.institution_id,
                            sku_id: this.custom_sku_id ? this.custom_sku_id : sku_obj.sku_id,
                        };
                        await http.post('/crm/product/sku/getSkuBatchList', params).then(res => {
                            if (res.success) {
                                this.customProductSkuBatchList = res.data;
                            }
                        })
                    }

                } catch (e) {
                    console.log(e)
                }
            },
            changeCustomTerritoryId(value, item) {
                this.custom_terrtory_id = value;

                this.extendedInfo.forEach(e => {
                    if(!e.default_value)
                    {
                        e.field_value = "";
                    }
                })

                this.getInstutionsListByTerritoryId(this.custom_terrtory_id);
                this.getDistributorListByTerritoryId(this.custom_terrtory_id);
            },
            changeCustomInstitution(value, item) {
                console.log(value);
                console.log(item);
                let field_value = this.customInstitutionList.find(e => e.institution_id == value);
                item.field_value = field_value.institution_name;
                item.institution_id = value;
                item.institution_name = field_value.institution_name;
                this.custom_institution_id = value;

                let fieldIndex = this.selectCustomTableRow.findIndex(e => e.field_id === item.field_id);
                this.selectCustomTableRow[fieldIndex] = item;

                this.getCustomProductSkuList();
            },
            changeCustomDistributor(value, item) {
                console.log(value);
                console.log(item);
                let field_value = this.customDistributorList.find(e => e.distributor_id == value);
                item.field_value = field_value.distributor_name;
                item.distributor_id = value;
                item.distributor_name = field_value.distributor_name;

                let fieldObj = this.selectCustomTableRow.find(e => e.field_name === "商业名称");
                fieldObj = item;
            },
            changeCustomProductSku(value, item) {
                console.log(value);
                let field_value = this.customProductSkuList.find(e => e.sku_id == value);
                item.field_value = field_value.sku_name;
                item.sku_id = value;
                item.sku_name = field_value.sku_name;
                this.custom_sku_id = value;

                let fieldIndex = this.selectCustomTableRow.findIndex(e => e.field_id === item.field_id);
                this.selectCustomTableRow[fieldIndex] = item;
                console.log(this.selectCustomTableRow)
                this.getCustomProductSkuBatchList();
            },
            changeCustomSkuBatch(value, item) {
                console.log(value);
                console.log(item);
                item.field_value = value;
                item.batch_no = value;

                let fieldObj = this.selectCustomTableRow.find(e => e.field_name === "批号");
                fieldObj = item;

                if(value==="无库存"){
                    let list = this.extendedInfo.filter(e => e.field_name.includes('库存量'));
                    console.log(list.length)
                    for (let sub_field of list) {
                    console.log(sub_field)
                        sub_field.field_value = "0";
                    }
                }
            },
			changeCustomField(e, item) {
				console.log(e)
				item.field_value =e //item.dictionary_array[e.detail.value].title;
			},
			radioChange(value, item) {
				this.setZhunruShow(item, true)
			},
            add() {

                // if(this.reference_obj == 'INSTITUTION'){
                let off = true
                if (this.extendedInfo.length > 0) {
                    for (let i = 0; i < this.extendedInfo.length; i++) {
                        if (this.extendedInfo[i].mandatory == 'T') {

                            this.$refs['list' + i][0].validate(valid => {
                                if (!valid) {
                                    off = false
                                }
                            })
                        }

                    }

                    //日常任务才有的判断
                    if (this.data.group_code && this.data.group_code == "ZR_DAILY_TASK") {
                        let is_write = false;
                        for (let item of this.extendedInfo) {
                            if (item.field_name === 'C_YSHQXXZS' && item.field_value) {
                                console.log("---item.C_YSHQXXZS",item.field_value)
                                is_write = true;
                                break;
                            }
                            if (item.field_name === 'C_LCTDXXTS' && item.field_value) {
                                console.log("---item.C_LCTDXXTS",item.field_value)
                                is_write = true;
                                break;
                            }
                            if (item.field_name === 'C_YSHLXXXTS' && item.field_value) {
                                console.log("---item.C_YSHLXXXTS",item.field_value)
                                is_write = true;
                                break;
                            }
                            if (item.field_name === 'C_ZRHCGYYYXXTS' && item.field_value) {
                                console.log("---item.C_ZRHCGYYYXXTS",item.field_value)
                                is_write = true;
                                break;
                            }
                        }
                        if (is_write == false) {
                            off = false
                            Message.error("请填写信息");
                        }
                    }
                    if (off) {
                        this.updateExtendedInfo()
                    }
                }

                // }else if(this.reference_obj == 'HCP'){
                //
                // }else if(this.reference_obj == 'RETAILSTORE'){
                //
                //
                // }else if(this.reference_obj == 'DISTRIBUTOR'){
                //
                //
                // }
            },
            updateExtendedInfo() {
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    user_id: this.$store.getters.getUser.user_id,
                    institution_id: this.institution_id,
                    task_id: this.task_id,
                    store_id: this.store_id,
                    hcp_id: this.hcp_id,
                    distributor_id: this.distributor_id,
                    reference_obj: this.reference_obj,
                    ExtensionArray: this.extendedInfo
                }
                http.post('/wapi/Collect/setExtendedList', data).then(res => {

                    if (res.success) {
                        Message({
                            type: 'success',
                            message: '保存成功'
                        })
                        this.dialogDetails = false
                        this.extendedInfo = []
                        this.getInstitutionList()


                    } else {
                        Message.error(res.message);

                    }
                })
            },
            saveCustomTable() {
                let off = true
                if (this.extendedInfo.length > 0) {
                    for (let i = 0; i < this.extendedInfo.length; i++) {
                        if (this.extendedInfo[i].mandatory == 'T' || this.extendedInfo[i].primary_key == 'T') {

                            this.$refs['list' + i][0].validate(valid => {
                                if (!valid) {
                                    off = false
                                }
                            })
                        }

                    }
                    //日常任务才有的判断
                    if (this.data.group_code && this.data.group_code == "ZR_DAILY_TASK") {
                        let is_write = false;
                        for (let item of this.extendedInfo) {
                            if (item.field_name === 'C_YSHQXXZS' && item.field_value) {
                                console.log("---item.C_YSHQXXZS",item.field_value)
                                is_write = true;
                                break;
                            }
                            if (item.field_name === 'C_LCTDXXTS' && item.field_value) {
                                console.log("---item.C_LCTDXXTS",item.field_value)
                                is_write = true;
                                break;
                            }
                            if (item.field_name === 'C_YSHLXXXTS' && item.field_value) {
                                console.log("---item.C_YSHLXXXTS",item.field_value)
                                is_write = true;
                                break;
                            }
                            if (item.field_name === 'C_ZRHCGYYYXXTS' && item.field_value) {
                                console.log("---item.C_ZRHCGYYYXXTS",item.field_value)
                                is_write = true;
                                break;
                            }
                        }
                        if (is_write == false) {
                            off = false
                            Message.error("请填写信息");
                        }
                    }
                    console.log(off)
                    if (off) {
                        this.updateCustomTableRow()
                    }
                }
            },
            updateCustomTableRow() {
                if(!this.custom_terrtory_id)
                {
                    Message.error("请选择辖区");
                    return
                }
                let batchNo = this.extendedInfo.find(e => e.batch_no != "" && e.batch_no != null);
                    console.log(batchNo)
                if (batchNo) {
					const regex = /^([A-Za-z0-9\/]+|无库存)+$/;
					let validValue = regex.test(batchNo.field_value);
					console.log(validValue)
					if(!validValue)
					{
                        Message.error("批号只能有字母和数字组成");
						return;
					}
				}
                let data = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    user_id: this.$store.getters.getUser.user_id,
                    task_id: this.task_id,
                    reference_obj: this.reference_obj,
                    territory_id: this.custom_terrtory_id,
                    row_id: this.add_custom_table ? "" : this.selectCustomTableRow[0].row_id,
                    ExtensionArray: this.extendedInfo
                }
                
                http.post('/crm/app/collection/saveCollectionCustomTable', data).then(res => {

                    if (res.data.success) {
                        Message({
                            type: 'success',
                            message: '保存成功'
                        })
                        this.dialogCustomTableDetails = false
                        this.extendedInfo = []
                        this.selectCustomTableRow = []
                        if(this.search_keyword){
                            this.changeSelectInstitution()
                        }else{
                            this.getCustomTableList()
                        }

                    } else {
                        Message.error(res.data.msg);

                    }
                })
            },
            close() {
                this.dialogDetails = false;
                this.dialogCustomTableDetails = false;
                this.dialogRules=false;
                this.selectCustomTableRow = [];
            },
            handleCustomApproveSubmit(status) {
                if (this.selectEndPointTerritory.length == 0) {
                    this.error("请选择辖区");
                    return;
                }
                if (status == "APPROVE") {
                    for (const item of this.selectEndPointTerritory) {
                        if (!item.customTable_staff_submit || item.customTable_staff_submit != "T") {
                            this.error("存在代表未提交的采集数据，请重新确认后审核");
                            return;
                        }
                    }
                } else if (status === "SUBMIT") {
                    for (const item of this.selectEndPointTerritory) {
                        if (!item.customTable_approve || item.customTable_approve != "T") {
                            this.error("存在代表未提交或者主管未审核的采集数据，请重新确认后提交");
                            return;
                        }
                    }
                }
                this.$confirm('确定进行该操作吗, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {

                    let loading1 = this.$loading({
                        lock: true,
                        text: '拼命加载中',
                        spinner: 'el-icon-loading',
                        background: 'rgba(0, 0, 0, 0.7)',
                    });
                    try {
                        console.log(this.customTableData)
                        let tenant_id = this.$store.getters.getUser.tenant_id;
                        let approveArray = [];

                        for (const item of this.customTableData) {
                            let territory_item = this.array.find(e=>e.territory_id===item[0].territory_id);
                            let tempItem = {
                                tenant_id: tenant_id,
                                territory_id: territory_item.territory_id,
                                owner_id: territory_item.owner_id,
                                status: status,
                            }
                            approveArray.push(tempItem);
                        }
                        let params = {
                            tenant_id: tenant_id,
                            manager_id: this.$store.getters.getUser.user_id,
                            task_id: this.task_id,
                            approve_array: approveArray,
                        };
                        http.post('/crm/web/collection/submitTaskCustomTable', params).then(res => {
                            loading1.close()
                            if (res.success) {
                                Message({
                                    type: 'success',
                                    message: status === 'APPROVE' ? "审核成功" : '提交成功'
                                })
                                this.getTerritoryList();
                            }
                        })

                    } catch (e) {
                        console.log(e)
                        loading1.close()
                    }
                }).catch(() => {

                });
            },
            async handleDownloadExpoler() {
                this.loading = true;
                let user = this.$store.getters.getUser;
                let params = {
                    tenant_id: user.tenant_id,
                    task_id: this.task_id,
                    territory_id: this.form.TerritoryList
                };
                await axios({
                    method: "post",
                    url: "/wapi/derive/exportCustomCollect",
                    data: params,
                    responseType: 'arraybuffer'
                    // responseType: "blob",
                })
                    .then((res) => {
                        console.log(res)
                        let blob = new Blob([res.data], {
                            type: "application/vnd.ms-excel;charset=utf-8",
                            //   type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
                        }); //然后创建blob对象，文件类型设置为excel的类型{type: "application/vnd.ms-excel"}
                        const elink = document.createElement("a");
                        elink.download = "采集情况统计.xlsx";
                        elink.style.display = "none";
                        elink.href = URL.createObjectURL(blob);
                        document.body.appendChild(elink);
                        elink.click();
                        URL.revokeObjectURL(elink.href); // 释放URL 对象
                        document.body.removeChild(elink);
                        this.loading = false;
                    })
                    .catch((e) => {
                        console.log(e);
                        this.loading = false;
                        this.$message.error("下载失败");
                    });
            },
            async handleDownloadCollectData() {
                let temp_tempArray = [];
                this.initArray.forEach(elment => {
                    temp_tempArray.push(elment.territory_id);
                })
                this.loading = true;
                this.reference_obj = "CUSTOMTABLE"
                let params = {
                    tenant_id: this.$store.getters.getUser.tenant_id,
                    user_id: this.$store.getters.getUser.user_id,
                    task_id: this.task_id,
                    territory_id: temp_tempArray,
                    reference_obj: this.reference_obj,
                    is_staff: this.is_staff_false ? "F" : "T"
                }
                await axios({
                    method: "post",
                    url: "/wapi/derive/exportZhunruMonthClientCollectionData",
                    data: params,
                    responseType: 'arraybuffer'
                    // responseType: "blob",
                })
                    .then((res) => {
                        console.log(res)
                        let blob = new Blob([res.data], {
                            type: "application/vnd.ms-excel;charset=utf-8",
                            //   type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
                        }); //然后创建blob对象，文件类型设置为excel的类型{type: "application/vnd.ms-excel"}
                        const elink = document.createElement("a");
                        elink.download = "采集填报数据明细下载.xlsx";
                        elink.style.display = "none";
                        elink.href = URL.createObjectURL(blob);
                        document.body.appendChild(elink);
                        elink.click();
                        URL.revokeObjectURL(elink.href); // 释放URL 对象
                        document.body.removeChild(elink);
                        this.loading = false;
                    })
                    .catch((e) => {
                        console.log(e);
                        this.loading = false;
                        this.$message.error("下载失败");
                    });
            },
            selectBack(item) {
                for (var i = 0; i < this.array.length; i++) {
                    this.array[i].isSelect = false
                }
                if (this.array.length > 1) {
                    this.checked = false
                }
                this.territoryArray = []
                let a = item.territory_id
                this.territoryArray.push(a)
                item.isSelect = true

                this.territory_name = item.territory_name
                this.territory_code = item.territory_code
                this.alias = item.owner_name

                if (this.activeName === "five") {
                    this.getCustomTableList();
                } else {
                    this.getInstitutionList()
                }
            },

            async initRemoteInstitution(){

                let params = {
                    tenant_id:this.$store.getters.getUser.tenant_id,
                    task_id:this.task_id,
                    territory_array:this.array
                }
                await http.post('/crm/web/collection/getCollectionInstitutionName', params).then(res => {
                    if (res.success) {
                        res.data.forEach(element => {
                            this.search_institution_name_list.push({
                                label:element.field_value,
                                value:element.field_value
                            })
                        });
                    }
                })
            },
            async remoteSearchMethod(query)
            {
                if (query !== '') {
                    setTimeout(() => {
                        this.search_institution_options = this.search_institution_name_list.filter(item => {
                            return item.label.toLowerCase()
                                .indexOf(query.toLowerCase()) > -1;
                            });
                    }, 200);
                } else {
                    this.search_institution_options = [];
                }
            },
            changeSelectInstitution(e)
            {
                this.territoryArray=[];
                this.array.forEach(element => {
                    element.isSelect=false;
                    if(this.search_keyword){
                        this.territoryArray.push(element.territory_id)
                    }
                });
                // this.checked_staff_draft=false;
                // this.checked_staff_submited =false;
                // this.checked_manager_approved = false;
                // this.checked_manager_no_approved = false;
                // this.checked_manager_submited=false;
                this.checked=false;
                this.getCustomTableList();
                this.territoryArray=[]
            },
            dianji3(item) {

                //                item.isSelect = !item.isSelect
                //                this.getApprovalHcpList()
                this.search_keyword="";
                if (this.territoryArray.length === 0) {
                    item.isSelect = true

                    this.territory_name = item.territory_name
                    this.territory_code = item.territory_code
                    this.alias = item.owner_name

                    this.territoryArray.push(item.territory_id)
                    this.selectEndPointTerritory.push(item);
                    if (this.activeName === "five") {
                        this.getCustomTableList();
                    } else {
                        this.getInstitutionList()
                    }
                    return
                }
                else {
                    var b = false
                    for (var i = 0; i < this.territoryArray.length; i++) {
                        let territory_id = this.territoryArray[i]
                        if (territory_id == item.territory_id) {
                            item.isSelect = false
                            this.territoryArray.splice(i, 1)
                            this.selectEndPointTerritory.splice(i, 1)
                            if (this.selectEndPointTerritory.length == 1) {

                                this.territory_name = this.selectEndPointTerritory[0].territory_name
                                this.territory_code = this.selectEndPointTerritory[0].territory_code
                                this.alias = this.selectEndPointTerritory[0].owner_name
                            }
                            b = true
                            if (this.activeName === "five") {
                                this.getCustomTableList();
                            } else {
                                this.getInstitutionList()
                            }
                            return
                        }
                    }
                    if (b === false) {
                        item.isSelect = true
                        this.territoryArray.push(item.territory_id)
                        this.selectEndPointTerritory.push(item)
                        console.log(this.selectEndPointTerritory)
                        if (this.selectEndPointTerritory.length == 1) {

                            this.territory_name = this.selectEndPointTerritory[0].territory_name
                            this.territory_code = this.selectEndPointTerritory[0].territory_code
                            this.alias = this.selectEndPointTerritory[0].owner_name
                        }
                        if (this.activeName === "five") {
                            this.getCustomTableList();
                        } else {
                            this.getInstitutionList()
                        }
                        return
                    }
                }

            },
            dianji4(item) {
                this.search_keyword="";
                this.checked = item;

                this.territoryArray = []
                this.selectEndPointTerritory = [];
                for (var i = 0; i < this.array.length; i++) {
                    this.array[i].isSelect = item
                    if (item) {
                        let a = this.array[i].territory_id
                        this.territoryArray.push(a)
                        this.selectEndPointTerritory.push(this.array[i]);
                        this.territory_name = this.array[i].territory_name
                        this.territory_code = this.array[i].territory_code
                        this.alias = this.array[i].alias
                    }
                    else {
                        this.territoryArray = []
                        this.selectEndPointTerritory = []
                        this.territory_name = ''
                        this.territory_code = ''
                        this.alias = null
                    }
                }
                if (this.activeName === "five") {
                    this.getCustomTableList();
                } else {
                    this.getInstitutionList()
                }
            },

            handleCheckFilter(check_value) {
                this.getApprovalListByTerritoryId();
            },
            handleBackClick() {
                this.$router.go(-1)
            },
            xuanze(value, option) {
                this.checked = ''
                this.territoryArray.length = 0
                this.selectEndPointTerritory = []
                this.insTableData = []
                this.hcpTableData = []
                this.storeTableData = []
                this.disTableData = []
                this.form.TerritoryList = value
                
                this.isInit = true;
                this.getApprovalListByTerritoryId()
            },
            async getTerritoryList() {
                let loading = this.$loading({
                    lock: true,
                    text: '拼命加载中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                try {
                    let data = {
                        user_id: this.$store.getters.getUser.user_id,
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        role: this.$store.getters.getUser.role,
                        task_id: this.task_id

                    }
                    let self = this
                    await http.post('/wapi/Collect/getCollTerritoryList', data).then(res => {


                        if (res.success) {

                            self.TerritoryList = res.data.qwArray
                            self.form.TerritoryList = self.TerritoryList[0].territory_id
                            self.taskTerritoryList = res.data.endPoint
                            this.getApprovalListByTerritoryId()
                            loading.close()
                        }
                    })
                } catch (e) {
                    loading.close()
                    Message.error(res.message);
                }


            },

            async getApprovalListByTerritoryId() {
                this.loading = true;
                try {
                    let data = {
                        tenant_id: this.$store.getters.getUser.tenant_id,
                        user_id: this.$store.getters.getUser.user_id,
                        role: this.$store.getters.getUser.role,
                        territory_id: this.form.TerritoryList,
                        taskTerritoryList: this.taskTerritoryList,
                        task_id: this.task_id,
                        customTable_staff_no_submit: this.checked_staff_draft ? "T" : "F",
                        customTable_staff_submit: this.checked_staff_submited ? "T" : "F",
                        customTable_approve: this.checked_manager_approved ? "T" : "F",
                        customTable_no_approve: this.checked_manager_no_approved ? "T" : "F",
                        customTable_submit: this.checked_manager_submited ? "T" : "F"
                    }
                    let self = this
                    self.array = [];
                    await http.post('/wapi/Collect/getApprovalListByTerritoryId', data).then(res => {

                        if (res.success) {

                            for (var i = 0; i < res.data.result.length; i++) {
                                res.data.result[i].isSelect = false
                                if (res.data.result[i].onboard_date) {
                                    res.data.result[i].onboard_date = moment(res.data[i].onboard_date).format('YYYY年MM月DD日')
                                }

                            }
                            self.array = res.data.result
                            if (self.isInit) {
                                self.isInit=false;
                                self.initArray = res.data.result;
                            }
                            if(self.is_staff_false)
                            {
                                self.manager_no_submit_territory_array = res.data.result.filter(e=>e.customTable_submit==="F"&& e.customTable_staff_submit=='T');
                            }else{
                                self.manager_no_submit_territory_array = res.data.result.filter(e=> e.customTable_staff_submit=='F');
                            }
                            self.territory_staff_draft_count = res.data.territory_staff_draft_count;
                            self.territory_staff_submited_count = res.data.territory_staff_submited_count;
                            self.territory_manager_no_approved_count = res.data.territory_manager_no_approved_count;
                            self.territory_manager_submited_count = res.data.territory_manager_submited_count;
                            self.territory_manager_approved_count = res.data.territory_manager_approved_count;

                            self.territoryArray = []
                            self.selectEndPointTerritory = []
                            // if (self.array.length > 0) {
                            //     if (self.array.length == 1) {
                            //         this.checked = true
                            //     }
                            //     let a = self.array[0].territory_id
                            //     self.territoryArray.push(a)
                            //     self.selectEndPointTerritory.push(self.array[0])
                            //     self.array[0].isSelect = true

                            //     self.territory_name = self.array[0].territory_name
                            //     self.territory_code = self.array[0].territory_code
                            //     self.alias = self.array[0].owner_name
                            // }
                            // self.dianji4(true);
                            if (this.activeName === "five") {
                                this.getCustomTableList();
                            } else {
                                this.getInstitutionList()
                            }


                            this.initRemoteInstitution();
                            this.loading = false;


                        } else {
                            this.loading = false;
                            Message.error(res.message);
                        }
                        this.$nextTick(() => {
                            new Swiper('.swiper-container', {
                                slidesPerView: "auto",
                                freeMode: true,
                                navigation: {
                                    nextEl: '.you',
                                    prevEl: '.zuo',
                                },
                            });
                        })

                    })
                } catch (e) {
                    this.loading = false;
                }


            },

        },

        computed: {

        },
        mounted() {

        },
        watch: {},
        updated() {

        }
    }
</script>

<style lang="scss" module>
    .container {
        background: white;
        height: 1000%;
        padding-bottom: 20px;
    }
</style>
<style scoped>
    .people>>>.el-form-item__label {
        font-size: 16px;
        color: #000000;
    }

    #customInfo>>>.el-dialog__header {
        padding-top: 0
    }

    #customInfo>>>.el-form-item__label {
        font-size: 14px;
        color: black;
        font-weight: bold;
        text-align: left;
        padding-left: 10px;
    }

    .businessClass>>>.el-form-item__label {
        font-size: 14px;
        color: #000000;
        font-weight: bold;
    }

    .HcpClass>>>.el-form-item__label {
        font-size: 14px;
        color: #000000;
        font-weight: bold;
    }

    .HcpClass1>>>.el-form-item__label {
        font-size: 14px;
        color: #000000;
        font-weight: bold;
        text-align: left;
        padding-left: 20px;
    }

    .box {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .swiper-container {

        width: calc(100% - 120px);
        height: 117px;
        background-color: #fff;
        display: flex;

    }

    .swiper-wrapper {
        height: 115px;
        width: 100%;
    }

    .swiper-slide {
        width: 200px;
        margin-right: 10px;
        background-color: #fff;
        border: 1px solid #ededed;
    }
</style>
<style>
    #div1 {
        display: none;
    }

    #div2 {
        display: none;
    }

    #div3 {
        display: none;
    }

    .headerStyle2>div {
        font-size: 14px;
        color: #585757;
        font-weight: bold;
    }

    .headerStyle2:nth-last-of-type(1)>div {
        color: #4A90E2;
    }

    .rule_tag{
        background-color: #f56c6c; 
        color: rgb(255, 255, 255);
        font-size: 12px; 
        border: 1px solid #f56c6c; 
        padding: 2px 5px; 
        border-radius: 3px;
        margin-right: 5px;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/pages/customCollect/components/zhunru_customCollectInfo.vue